import React, { Component } from "react";
import {
    Switch,
    message,
    Spin,
    Select,
    Row,
    Col,
    Input,
    Typography,
    Tooltip,
    Form as FormInitial,
} from "antd";
import { ColorPicker } from "antd5";
import { cuentaMask, Form, FormItem, ButtonItem, InputItem, InputNumberItem, SelectInsumosItem, SelectItem, SidebarMenu, SwitchItem } from "../../../../Components/Items";
import axios from "axios";
import { connect } from "react-redux";
import { LockOutlined, SettingOutlined, QuestionCircleOutlined, InfoCircleOutlined, MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import DynamicCardForm from "../../../../Components/DynamicCardForm";
import RichTextEditor from "../../../../Components/RichTextEditor";
import SeriesVenta from "./SeriesVenta/SeriesVenta";
import ConfigSwitch, { ConfigDependientes, ModulosBiwoContext, bloqueoModuloBiwo } from "../../../../Components/Config/ConfigSwitch";
import * as capturas from "../../../../assets/complementos";
import { MockFrame, MockButton, MockField, MockMenuItem, MockTable, MockDiff } from "../../../../Components/Config/ConfigMock";
import { SECTION_TITLES, MENU_ITEMS, SUBSECCIONES, PISTAS_SECCION_LIBRE } from "./menuComplementos";

const { Option } = Select;
const { Text } = Typography;

const TEXTOS_PAGARE = [
    { key: "<montoVenta>", desc: "Importe total de la venta con formato moneda." },
    { key: "<montoVentaLetras>", desc: "Importe total de la venta en letras, con la moneda." },
    { key: "<fechaVenta>", desc: "Fecha de la venta (DD/MM/YYYY)." },
    { key: "<fechaLargaVenta>", desc: "Fecha de la venta en formato largo." },
    { key: "<fechaPago>", desc: "Fecha de vencimiento/pago (DD/MM/YYYY)." },
    { key: "<fechaLargaPago>", desc: "Fecha de vencimiento en formato largo." },
    { key: "<nombreCliente>", desc: "Nombre o razón social del cliente." },
    { key: "<calleCliente>", desc: "Calle de la dirección principal del cliente." },
    { key: "<numeroCalleCliente>", desc: "Número exterior / interior del cliente." },
    { key: "<coloniaCliente>", desc: "Colonia del cliente." },
    { key: "<municipioCliente>", desc: "Municipio del cliente." },
    { key: "<estadoCliente>", desc: "Estado del cliente." },
    { key: "<cpCliente>", desc: "Código postal del cliente." },
    { key: "<rfcCliente>", desc: "RFC del cliente." },
];

const EMPRESA_AUTORIZADA = "6806caa1cac97810f8775682";

const CONFIG_RANGOS = [
    { color: "#dcfae6", label: "Rango 1" },
    { color: "#a7f5bf", label: "Rango 2" },
    { color: "#f7e191", label: "Rango 3" },
    { color: "#fad0b0", label: "Rango 4" },
    { color: "#f89f9f", label: "Rango 5" }
];

const CONFIG_COTIZACIONES = [
    { color: "#dcfae6", label: "Rango 1 (Cotización)" },
    { color: "#f7e191", label: "Rango 2 (Cotización)" },
    { color: "#f89f9f", label: "Rango 3 (Cotización)" },
];

const CONFIG_LOTES = [
    { color: "#dcfae6", label: "Rango 1 (Lote)" },
    { color: "#a7f5bf", label: "Rango 2 (Lote)" },
    { color: "#f7e191", label: "Rango 3 (Lote)" },
    { color: "#fad0b0", label: "Rango 4 (Lote)" },
    { color: "#f89f9f", label: "Rango 5 (Lote)" }
];

const CONFIG_OC = [
    { color: "#dcfae6", label: "Rango 1 (OC)" },
    { color: "#a7f5bf", label: "Rango 2 (OC)" },
    { color: "#f7e191", label: "Rango 3 (OC)" },
    { color: "#fad0b0", label: "Rango 4 (OC)" },
    { color: "#f89f9f", label: "Rango 5 (OC)" }
];


class ComplementosConfiguracion extends Component {
    formRef = React.createRef();
    pagareEditorRef = React.createRef();

    state = {
        loading: false,
        todasUnidadesPeso: null,
        objetoUnidadesPeso: null,
        todasUniadesDeNegocioFinales: null,
        objetoUniadesDeNegocioFinales: null,
        todasTipoDeCliente: [],
        objetoTipoDeCliente: null,
        apiURREA: false,
        todasCuentaContable: [],
        objetoCuentaContable: null,
        isMobile: window.innerWidth < 768,
        complementoSeriesPersonalizadas: false,
        modulosBiwo: { bloqueados: [], dependientes: {} },
    }

    componentDidMount() {
        this.handleResize = () => this.setState({ isMobile: window.innerWidth < 768 });
        window.addEventListener('resize', this.handleResize);
        this.consultarConfiguracion()
        axios
            .post("cobroBiwo/selectModulosControladosEmpresa", { empresaId: this.props.empresaId }, { headers: this.props.headersToken })
            .then((res) => {
                if (res.data.success === 2) this.setState({ modulosBiwo: { bloqueados: res.data.data, dependientes: res.data.dependientes || {} } });
            });
    }

    bloqueado = (clave, getFieldValue = (campo) => this.formRef.current?.getFieldValue(campo)) => !!bloqueoModuloBiwo(this.state.modulosBiwo, clave, getFieldValue);

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }
    normColor = (color) => {
        if (!color) return null;
        if (typeof color === "string") return color;
        if (typeof color.toHexString === "function") return color.toHexString();
        return null;
    };
    onFinish() {
        this.setState({ loading: true })
        const allValues = this.formRef.current.getFieldsValue(true);
        axios
            .post(
                "empresas/editarConfiguracionComplementos",
                { ...allValues, empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false })
                if (res.data.success === 2) {
                    message.success("Se ha modificado la configuracion de la empresa");
                } else if (res.data.success === 1) {
                    message.error(res.data.message || "No se pudo modificar la configuracion");
                } else {
                    message.error("Hubo un error y no se modifico la configuracion");
                }
            });
        axios
            .post(
                "configuracionOrdenesDeCompra/editarConfiguracionOrdenesDeCompra",
                {
                    empresaId: this.props.empresaId,
                    usarColoresPendientesOC: allValues.usarColoresPendientesOC,
                    rangosPendientesOC: allValues.rangosPendientesOC,
                    correosCopiaOrdenCompra: allValues.correosCopiaOrdenCompra,
                },
                { headers: this.props.headersToken }
            );
    }
    async consultarConfiguracion() {
        this.setState({ loading: true })
        await axios
            .post(
                "empresas/selectConfiguracionComplementos",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                    message.error("Error no se encontro configuracion de esta empresa");
                } else {
                    let rangosData = res.data.rangosDiasVencimiento || [];

                    const estructuraBase = CONFIG_RANGOS.map((conf, index) => ({
                        index: index,
                        tope: index === 4 ? -1 : (index + 1) * 2,
                        nombre: conf.label
                    }));

                    const rangosFinales = estructuraBase.map((itemBase, i) => {
                        const datoExistente = rangosData.find(r => r.index === i);
                        return datoExistente ? datoExistente : itemBase;
                    });

                    let rangosCotiData = res.data.rangosCotizaciones || [];

                    const estructuraCotiBase = CONFIG_COTIZACIONES.map((conf, index) => ({
                        index: index,
                        tope: index === 2 ? -1 : (index + 1) * 5,
                        nombre: conf.label,
                        color: conf.color
                    }));

                    const rangosCotiFinales = estructuraCotiBase.map((itemBase, i) => {
                        const datoExistente = rangosCotiData.find(r => r.index === i);
                        return datoExistente ? datoExistente : itemBase;
                    });

                    let rangosLotesData = res.data.rangosLotes || [];

                    const estructuraLotesBase = CONFIG_LOTES.map((conf, index) => ({
                        index: index,
                        tope: index === 2 ? -1 : (index + 1) * 30,
                        nombre: conf.label,
                        color: conf.color
                    }));

                    const rangosLotesFinales = estructuraLotesBase.map((itemBase, i) => {
                        const datoExistente = rangosLotesData.find(r => r.index === i);
                        return datoExistente ? datoExistente : itemBase;
                    });

                    this.setState({ complementoSeriesPersonalizadas: !!res.data.complementoSeriesPersonalizadas });

                    this.formRef.current.setFieldsValue({
                        envios:
                            res.data.envios,
                        embarques:
                            res.data.embarques,
                        fletes:
                            res.data.fletes,
                        unidadPesoId:
                            res.data.unidadPesoId,
                        complementoDetallista:
                            res.data.complementoDetallista,
                        complementoSeriesPersonalizadas:
                            res.data.complementoSeriesPersonalizadas,
                        insumosXCliente:
                            res.data.insumosXCliente,
                        modulosMezcal:
                            res.data.modulosMezcal,
                        modulosConsignaciones:
                            res.data.modulosConsignaciones,
                        equipoMedico:
                            res.data.equipoMedico,
                        lotesCaducidades:
                            res.data.lotesCaducidades,
                        filtrosAvanzadosInsumos:
                            res.data.filtrosAvanzadosInsumos,
                        unidadDeNegocioConsignacionesId:
                            res.data.unidadDeNegocioConsignacionesId,
                        kiosko:
                            res.data.kiosko,
                        kioskoTipoDeClienteId:
                            res.data.kioskoTipoDeClienteId,
                        kioskoPlazo:
                            res.data.kioskoPlazo,
                        tikets:
                            res.data.tikets,
                        segundoTicket:
                            res.data.segundoTicket,
                        impresionTicketsCredito:
                            res.data.impresionTicketsCredito,
                        impresionTicketsContado:
                            res.data.impresionTicketsContado,
                        predeterminarCXC:
                            res.data.predeterminarCXC,
                        duplicarVentas:
                            res.data.duplicarVentas,
                        vendedorVentas:
                            res.data.vendedorVentas,
                        cotizadorPorInsumo:
                            res.data.cotizadorPorInsumo,
                        preCotizacionIngenieria:
                            res.data.preCotizacionIngenieria,
                        ordenesMaquila:
                            res.data.ordenesMaquila,
                        producirSinInventario:
                            res.data.producirSinInventario,
                        mandarIngresoProyectoVentas:
                            res.data.mandarIngresoProyectoVentas,
                        desactivarSeparacionDescuentoVentas:
                            res.data.desactivarSeparacionDescuentoVentas,
                        desactivarCargaExcelInsumosVentas:
                            res.data.desactivarCargaExcelInsumosVentas,
                        entregarDisponiblesVenta:
                            res.data.entregarDisponiblesVenta,
                        separarConceptoIngresoPorInsumo:
                            res.data.separarConceptoIngresoPorInsumo,
                        facturarConDevoluciones:
                            res.data.facturarConDevoluciones,
                        ponerVendedor:
                            res.data.ponerVendedor,
                        ponerCanal:
                            res.data.ponerCanal,
                        ponerMetodoDePago:
                            res.data.ponerMetodoDePago,
                        quitarImpuestosRemisiones:
                            res.data.quitarImpuestosRemisiones,
                        quitarImpuestosFacturas:
                            res.data.quitarImpuestosFacturas,
                        importeConImpuestos:
                            res.data.importeConImpuestos,
                        cargarXmlPrevio:
                            res.data.cargarXmlPrevio,
                        puntoDeVenta:
                            res.data.puntoDeVenta,
                        separarInsumosRequisicion:
                            res.data.separarInsumosRequisicion,
                        separarDiasRequisicion:
                            res.data.separarDiasRequisicion,
                        agregarInsumosRequisicion:
                            res.data.agregarInsumosRequisicion,
                        mostrarCostosRequisicion:
                            res.data.mostrarCostosRequisicion,
                        cuentasImpagables:
                            res.data.cuentasImpagables,
                        cuentasIncobrables:
                            res.data.cuentasIncobrables,
                        cuentasAjusteCentavosCxC:
                            res.data.cuentasAjusteCentavosCxC,
                        cuentasAjusteCentavosCxP:
                            res.data.cuentasAjusteCentavosCxP,
                        desactivarSeparacionMovimientosCobranza:
                            res.data.desactivarSeparacionMovimientosCobranza,
                        desactivarSeparacionMovimientosPagos:
                            res.data.desactivarSeparacionMovimientosPagos,
                        pagoConCuentaContableCxP:
                            res.data.pagoConCuentaContableCxP,
                        cuentaContablePagoCxPId:
                            res.data.cuentaContablePagoCxPId,
                        textoAdicionalTicketRemision:
                            res.data.textoAdicionalTicketRemision,
                        textoAdicionalTicketFactura:
                            res.data.textoAdicionalTicketFactura,
                        activarPagare:
                            res.data.activarPagare,
                        pagareCorto:
                            res.data.pagareCorto,
                        textoPagare:
                            res.data.textoPagare,
                        tamañoTextoPagare:
                            res.data.tamañoTextoPagare,
                        textoAdicional:
                            res.data.textoAdicional,
                        tamañoTextoAdicional:
                            res.data.tamañoTextoAdicional,
                        textoAdicionalPedidosCotizaciones:
                            res.data.textoAdicionalPedidosCotizaciones,
                        tamañoTextoAdicionalPedidosCotizaciones:
                            res.data.tamañoTextoAdicionalPedidosCotizaciones,
                        conteos:
                            res.data.conteos,
                        apiURREA:
                            res.data?.apiURREA,
                        usuarioURREA:
                            res.data?.usuarioURREA,
                        passwordURREA:
                            res.data?.passwordURREA,
                        ventaOnline:
                            res.data?.ventaOnline,
                        appMovil:
                            res.data?.appMovil,
                        checadaRemota:
                            res.data?.checadaRemota,
                        verificacionFacial:
                            res.data?.verificacionFacial,
                        celularUnicoChecada:
                            res.data?.celularUnicoChecada === true,
                        observacionesPdf:
                            res.data.observacionesPdf,
                        facturaZip:
                            res.data.facturaZip,
                        contadoACredito:
                            res.data.contadoACredito,
                        facturaVariasRemisiones:
                            res.data.facturaVariasRemisiones,
                        facturaFechaAnterior:
                            res.data.facturaFechaAnterior,
                        anticipos:
                            res.data.anticipos,
                        insumoAnticipoId:
                            res.data.insumoAnticipoId,
                        ventasNoContables:
                            res.data.ventasNoContables,
                        quitarImpuestosOpcionalVentas:
                            res.data.quitarImpuestosOpcionalVentas,
                        permitirCambiarClienteVenta:
                            res.data.permitirCambiarClienteVenta,
                        permitirCambiarInsumoVenta:
                            res.data.permitirCambiarInsumoVenta,
                        permitirBajaLotesReemplazoVentas:
                            res.data.permitirBajaLotesReemplazoVentas,
                        permitirEditarRemisionVenta:
                            res.data.permitirEditarRemisionVenta,
                        permitirDividirVentaPorPartidas:
                            res.data.permitirDividirVentaPorPartidas,
                        cerrarPedidos:
                            res.data.cerrarPedidos,
                        avisoVentasPorEntregarVendedor:
                            res.data.avisoVentasPorEntregarVendedor,
                        finiquitarPedidos:
                            res.data.finiquitarPedidos,
                        semanaPedidos:
                            res.data.semanaPedidos,
                        apartarInsumosPedidos:
                            res.data.apartarInsumosPedidos,
                        pdfApartadoPedido:
                            res.data.pdfApartadoPedido,
                        entregarInsumosPedidos:
                            res.data.entregarInsumosPedidos,
                        generarRequisicionPedidos:
                            res.data.generarRequisicionPedidos,
                        importarPedidosIMSS:
                            res.data.importarPedidosIMSS,
                        editarCotizacionesTerminadas:
                            res.data.editarCotizacionesTerminadas,
                        finiquitarCotizaciones:
                            res.data.finiquitarCotizaciones,
                        formatoRequerimientoCotizaciones:
                            res.data.formatoRequerimientoCotizaciones,
                        editarTodasLasPolizas:
                            res.data.editarTodasLasPolizas,
                        verPolizaAlRealizarMovimiento:
                            res.data.verPolizaAlRealizarMovimiento,
                        cantidadAnticipoDefault:
                            res.data.cantidadAnticipoDefault,
                        programarRecordatorioCxC:
                            res.data.programarRecordatorioCxC,
                        factorajeFinancieroCXC:
                            res.data.factorajeFinancieroCXC,
                        complementoComercioExterior:
                            res.data.complementoComercioExterior,
                        complementoPSWPedidos:
                            res.data.complementoPSWPedidos,
                        complementoEmpresaAlterna:
                            res.data.complementoEmpresaAlterna,
                        activarEtiquetaEntregaPedido:
                            res.data.activarEtiquetaEntregaPedido,
                        unidadTiempoProduccion:
                            res.data.unidadTiempoProduccion || "minutos",
                        arrastrarDesfaseProduccionEntreDias:
                            res.data.arrastrarDesfaseProduccionEntreDias,
                        etiquetaEntregaPedidoAnchoMm:
                            res.data.etiquetaEntregaPedidoAnchoMm,
                        etiquetaEntregaPedidoLeyenda:
                            res.data.etiquetaEntregaPedidoLeyenda,
                        etiquetaEntregaPedidoLogo:
                            res.data.etiquetaEntregaPedidoLogo || "empresa",
                        ocultarColumnaIVA:
                            res.data.ocultarColumnaIVA,
                        cantidadJuntoPrecioUnitario:
                            res.data.cantidadJuntoPrecioUnitario,
                        precioUnitarioConDescuento:
                            res.data.precioUnitarioConDescuento,
                        imprimirImagenesCotizaciones:
                            res.data.imprimirImagenesCotizaciones,
                        regularizarInventarioVentas:
                            res.data.regularizarInventarioVentas,
                        regularizarInventarioVentasAbajo:
                            res.data.regularizarInventarioVentasAbajo,
                        regularizarInventarioVentasAutomaticoPAC:
                            res.data.regularizarInventarioVentasAutomaticoPAC,
                        cuentaAbonoRegularizarInventarioId:
                            res.data.cuentaAbonoRegularizarInventarioId,
                        deshabilitarBanco:
                            res.data.deshabilitarBanco,
                        imprimirIEPS:
                            res.data.imprimirIEPS,
                        tipoPDF:
                            res.data.tipoPDF || "clasico",
                        colorPdf:
                            res.data.colorPdf || "#00b5e2",
                        decimalesTipoCambioPdf:
                            res.data.decimalesTipoCambioPdf,
                        decimalesPrecioUnitarioPdf:
                            res.data.decimalesPrecioUnitarioPdf,
                        decimalesCantidadPdf:
                            res.data.decimalesCantidadPdf,
                        decimalesEmpresa:
                            res.data.decimalesEmpresa,
                        paquetes:
                            res.data.paquetes,
                        deshabilitarClaveCot:
                            res.data.deshabilitarClaveCot,
                        deshabilitarClaveSATCot:
                            res.data.deshabilitarClaveSATCot,
                        deshabilitarClaveInterna:
                            res.data.deshabilitarClaveInterna,
                        deshabilitarRegimenFiscal:
                            res.data.deshabilitarRegimenFiscal,
                        mostrarDirFiscalEnPdf:
                            res.data.mostrarDirFiscalEnPdf,
                        deshabilitarMonedaPdf:
                            res.data.deshabilitarMonedaPdf,
                        deshabilitarLugarExpedicionPdf:
                            res.data.deshabilitarLugarExpedicionPdf,
                        deshabilitarCondicionesPagoPdf:
                            res.data.deshabilitarCondicionesPagoPdf,
                        deshabilitarTipoComprobantePdf:
                            res.data.deshabilitarTipoComprobantePdf,
                        deshabilitarOCPdf:
                            res.data.deshabilitarOCPdf,
                        deshabilitarCPClientePdf:
                            res.data.deshabilitarCPClientePdf,
                        deshabilitarFormaPagoPdf:
                            res.data.deshabilitarFormaPagoPdf,
                        deshabilitarMetodoPagoPdf:
                            res.data.deshabilitarMetodoPagoPdf,
                        ocultarColumnaPU:
                            res.data.ocultarColumnaPU,
                        ocultarColumnaImporte:
                            res.data.ocultarColumnaImporte,
                        ocultarCuadroTotalesPdf:
                            res.data.ocultarCuadroTotalesPdf,
                        mostrarReferenciaEntregaPdf:
                            res.data.mostrarReferenciaEntregaPdf,
                        camposFirmaVentas:
                            res.data.camposFirmaVentas,
                        deshabilitarBancoFactura:
                            res.data.deshabilitarBancoFactura,
                        deshabilitarFechaPdf:
                            res.data.deshabilitarFechaPdf,
                        deshabilitarFechaEntregaPdf:
                            res.data.deshabilitarFechaEntregaPdf,
                        imprimirDesUnidad:
                            res.data.imprimirDesUnidad,
                        imprimirDescripcionInsumoOC:
                            res.data.imprimirDescripcionInsumoOC,
                        desactivarBtnCXC:
                            res.data.desactivarBtnCXC,
                        quitarFechaVen: res.data.quitarFechaVen,
                        rangosDiasVencimiento: rangosFinales,
                        usarColoresVencimiento: res.data.usarColoresVencimiento,
                        diasPredetVen: res.data.diasPredetVen,
                        usarColoresCot: res.data.usarColoresCot,
                        rangosCotizaciones: rangosCotiFinales,
                        usarColoresLotes: res.data.usarColoresLotes,
                        rangosLotes: rangosLotesFinales,
                        controlAsistencia:
                            res.data.controlAsistencia,
                        nomina:
                            res.data.nomina,
                        timbradoDePrueba:
                            res.data.timbradoDePrueba,
                        timbrarNominaHistorica:
                            res.data.timbrarNominaHistorica,
                        altaEmpleadoPorPasos:
                            res.data.altaEmpleadoPorPasos === true,
                        mostrarProyectoVentas:
                            res.data.mostrarProyectoVentas,
                        docObligatorio:
                            res.data.docObligatorio,
                        cantidadDefault:
                            res.data.cantidadDefault,
                        workbenchRequisiciones:
                            res.data.workbenchRequisiciones,
                        moduloCalidad:
                            res.data.moduloCalidad,
                        crm:
                            res.data.crm,
                        evaluacionProveedores:
                            res.data.evaluacionProveedores,
                        whatsapp:
                            res.data.whatsapp,
                        whatsappNumeroPorUsuario:
                            !!res.data.whatsappNumeroPorUsuario,
                        camposFirmaOC :
                            res.data.camposFirmaOC,
                        aprobarOrdenesDeCompra:
                            res.data.aprobarOrdenesDeCompra,
                        autorizacionesRapidas:
                            res.data.autorizacionesRapidas,
                        moduloWms:
                            res.data.moduloWms,
                        moduloActivosFijos:
                            res.data.moduloActivosFijos,
                        moduloCMMS:
                            res.data.moduloCMMS,
                        moduloHoteleria:
                            res.data.moduloHoteleria,
                        moduloRMA:
                            res.data.moduloRMA,
                        moduloRMACompras:
                            res.data.moduloRMACompras,
                        consultarProveedoresOnline:
                            res.data.consultarProveedoresOnline,
                        comodatoPorDefectoProveedor:
                            res.data.comodatoPorDefectoProveedor,
                        comodatoFechaEntregaObligatoria:
                            res.data.comodatoFechaEntregaObligatoria,
                        editarCostosOrdenDeCompra:
                            res.data.editarCostosOrdenDeCompra,
                        verComoSistemaOCPorDefecto:
                            res.data.verComoSistemaOCPorDefecto,
                        imprimirObservacionesOCPorDefecto:
                            res.data.imprimirObservacionesOCPorDefecto,
                        separacionInsumosSimpleOC:
                            res.data.separacionInsumosSimpleOC,
                        separacionInsumosPorClienteOC:
                            res.data.separacionInsumosPorClienteOC,
                        separacionInsumosPorDiaOC:
                            res.data.separacionInsumosPorDiaOC,
                        mostrarPdfMovimientosInventario:
                            res.data.mostrarPdfMovimientosInventario,
                        predefinirGlobalPorLineaVenta:
                            res.data.predefinirGlobalPorLineaVenta,
                        escuela:
                            res.data.escuela,
                        camposCalidad: res.data.camposCalidad ?? {
                            programa: { duracionEstimada: true, metadatos: true },
                            proceso:  { toleranciaRetardo: true, requireAprobacion: true, requirePresencia: true, duracionEstimada: true, metadatos: true },
                            punto:    { pasos: true, criterioTolerancia: true, criterioReferencias: true, riesgos: true },
                        },
                        prorrateoDesCostos: res.data.prorrateoDesCostos,
                        cuentaContableProrrateoId: res.data.cuentaContableProrrateoId,
                        mostrarComplementoPagoFacturas: res.data.mostrarComplementoPagoFacturas,
                        vencimientoDesdeRecepcionFactura: res.data.vencimientoDesdeRecepcionFactura === true,
                        // buscadorMenu: res.data.buscadorMenu !== false,
                    });
                    this.setState(
                        {
                            apiURREA: res.data?.apiURREA,
                        });
                }
            });
        await axios
            .post(
                "configuracionOrdenesDeCompra/selectConfiguracionOrdenesDeCompra",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    const rangosPendientesOCData = res.data.rangosPendientesOC || [];

                    const estructuraPendientesOCBase = CONFIG_OC.map((conf, index) => ({
                        index: index,
                        tope: (index + 1) * 5,
                        nombre: conf.label,
                        color: conf.color
                    }));

                    const rangosPendientesOCFinales = estructuraPendientesOCBase.map((itemBase, i) => {
                        const datoExistente = rangosPendientesOCData.find(r => r.index === i);
                        return datoExistente ? datoExistente : itemBase;
                    });

                    this.formRef.current.setFieldsValue({
                        usarColoresPendientesOC: res.data.usarColoresPendientesOC,
                        rangosPendientesOC: rangosPendientesOCFinales,
                        correosCopiaOrdenCompra: res.data.correosCopiaOrdenCompra || [],
                    });
                }
            });
        axios
            .post(
                "cuentascontables/selectCuentasContablesFinales",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({
                        todasCuentaContable: res.data,
                        objetoCuentaContable: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {cuentaMask(value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5) + ' - ' + value.descripcion}
                                </Option>
                            );
                        }),
                    });
                }
            });
        await axios
            .post(
                "unidades/selectUnidadesPeso",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                    // message.error("No se encotraron unidades de peso");
                } else {
                    this.setState({
                        todasUnidadesPeso: res.data,
                        objetoUnidadesPeso: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.unidadSat.c_ClaveUnidad + " - " + value.nombre}
                                </Option>
                            );
                        }),
                    })
                }
            });
        await axios
            .post(
                "unidadesdenegocio/selectUnidadesDeNegocioFinales",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                } else {
                    this.setState({ todasUniadesDeNegocioFinales: res.data });
                    this.setState({
                        objetoUniadesDeNegocioFinales: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {cuentaMask(
                                        value.nivel1 + value.nivel2 + value.nivel3 + value.nivel4 + value.nivel5
                                    ) +
                                        " - " +
                                        value.nombre}
                                </Option>
                            );
                        }),
                    });
                }
            });

        await axios
            .post(
                "tiposDeClientes/selectTiposDeClientes",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                    message.error("No se encotraron tipos de clientes");
                } else {
                    this.setState({
                        todasTipoDeCliente: res.data,
                        objetoTipoDeCliente: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " - " + value.descripcion}
                                </Option>
                            );
                        }),
                    })
                }
            });

        await axios
            .post(
                "usuarios/selectUsuariosEmpresa",
                { empresaId: this.props.empresaId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.status === 404) {
                    message.error("No se encotraron tipos de clientes");
                } else {
                    this.setState({
                        todosVendedores: res.data,
                        objetoVendedor: res.data.map((value) => {
                            return (
                                <Option value={value._id} key={value._id}>
                                    {value.nombre + " " + value.apellidoPaterno + " " + value.apellidoMaterno}
                                </Option>
                            );
                        }),
                    })
                }
            });

        this.setState({ loading: false })
    }
    onFinishFailed(e) {
        e.errorFields.map((value, index) => {
            if (e.errorFields[index].name[1]) {
                message.error(
                    "Error: " +
                    e.errorFields[index].errors[0] +
                    " en la fila " +
                    (e.errorFields[index].name[1] + 1)
                );
            } else {
                message.error("Error: Falta un campo");
            }
            return null;
        });
    }

    isEmpresaAutorizada = () => {
        return this.props.empresaId === EMPRESA_AUTORIZADA;
    };

    // Módulo que todavía no tiene opciones. El renglón del menú existe para
    // que el sidebar de configuración calque el menú principal; al entrar se
    // avisa que no hay nada que configurar y, si su interruptor vive en otra
    // sección, se dice dónde está.
    renderSeccionLibre(seccion, subseccion) {
        // La pista sólo tiene sentido en la portada del módulo: si el usuario
        // ya se metió a una pantalla concreta, basta el aviso.
        const pista = subseccion && subseccion !== 'general'
            ? null
            : PISTAS_SECCION_LIBRE[seccion];
        const que = subseccion && subseccion !== 'general' ? "Esta pantalla" : "Este módulo";
        return (
            <div style={{ padding: "26px 8px", maxWidth: 520 }}>
                <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                    <SettingOutlined style={{ fontSize: 16, color: "#d9d9d9", marginTop: 2, flexShrink: 0 }} />
                    <div>
                        <div style={{ fontSize: 14, fontWeight: 500, color: "#8c8c8c", lineHeight: 1.4 }}>
                            {que} todavía no tiene opciones de configuración.
                        </div>
                        {pista && (
                            <div style={{ fontSize: 12.5, color: "#b0b0b0", lineHeight: 1.5, marginTop: 4 }}>
                                {pista}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }

    // Nota al inicio de una pantalla: dice qué NO está aquí y dónde vive.
    // Se usa entre las tres pantallas de PDF, que son las que se pueden
    // confundir entre sí: cada una avisa dónde están las otras.
    renderNota(texto) {
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 8,
                    background: "#fbfdfe",
                    border: "1px solid #e9f5f8",
                    borderLeft: "3px solid #00BFD6",
                    borderRadius: 5,
                    padding: "8px 10px",
                    marginBottom: 16,
                }}
            >
                <InfoCircleOutlined style={{ color: "#00BFD6", fontSize: 13, marginTop: 2, flexShrink: 0 }} />
                <div style={{ fontSize: 12.5, lineHeight: 1.5, color: "#7d7d7d" }}>{texto}</div>
            </div>
        );
    }

    avisoModulo(clave, nombre) {
        return (
            <FormItem shouldUpdate={(prev, cur) => prev[clave] !== cur[clave]} noStyle>
                {({ getFieldValue }) =>
                    !getFieldValue(clave) &&
                    this.renderNota(<>{nombre} no está activado. Se activa en la pestaña <b>Complementos</b>.</>)
                }
            </FormItem>
        );
    }

    renderSoloActivacion(clave, nombre) {
        return (
            <div style={{ maxWidth: 640 }}>
                <FormItem shouldUpdate={(prev, cur) => prev[clave] !== cur[clave]} noStyle>
                    {({ getFieldValue }) =>
                        this.renderNota(
                            getFieldValue(clave)
                                ? <>{nombre} está activado y no tiene más opciones de configuración. Se administra en la pestaña <b>Complementos</b>.</>
                                : <>{nombre} no está activado. Se activa en la pestaña <b>Complementos</b>.</>
                        )
                    }
                </FormItem>
            </div>
        );
    }

    renderDivider(title) {
        const negMargin = this.state.isMobile ? -12 : -24;
        return (
            <div style={{
                background: '#f5f5f5',
                borderTop: '1px solid #ebebeb',
                borderBottom: '1px solid #ebebeb',
                padding: '9px 24px',
                margin: `12px ${negMargin}px`,
            }}>
                <Text strong style={{ fontSize: 14, color: '#444' }}>
                    {title}
                </Text>
            </div>
        );
    }

    renderVentasGeneral() {
        return (
            <Row gutter={[28, 0]}>
                <Col xs={24} md={12} xl={8}>
                    <ConfigSwitch
                        name="cargarXmlPrevio"
                        titulo="Cargar XML Previo"
                        resumen="Deja subir XML ya timbrados en otro sistema a las ventas."
                        aviso="Sólo se recomienda al arrancar el sistema o para facturas que vienen de otro sistema."
                        detalle="Se activa la carga de xml previos en ventas (Solo se recomienda para inicios del sistema o para facturas provenientes de otro sistema)."
                    />

                    <ConfigSwitch
                        name="predefinirGlobalPorLineaVenta"
                        initialValue={false}
                        titulo="Predefinir Global por Línea de Venta"
                        resumen="Cada línea de la venta trae ya marcado su estatus Global."
                        detalle="Al activarse, se predefine el estatus Global por cada línea de la venta."
                    />

                    <ConfigSwitch
                        name="predeterminarCXC"
                        titulo="Predeterminar CXC (PUE)"
                        resumen="En las ventas PUE, la cuenta por cobrar se llena sola."
                        aviso='No se puede activar junto con "Desactivar Botón de CXC en Ventas".'
                        detalle='Se pondrá la cuenta por cobrar predeterminada en las ventas cuando sean (PUE). No se puede activar junto con "Desactivar Botón de CXC en Ventas".'
                        afterChange={(checked) => {
                            if (checked) {
                                this.formRef.current.setFieldsValue({ desactivarBtnCXC: false })
                            }
                        }}
                    />

                    <ConfigSwitch
                        name="ponerVendedor"
                        titulo="Poner Vendedor"
                        resumen="Al elegir el cliente, su vendedor asignado se llena solo."
                        maqueta={
                            <MockFrame title="Agregar venta">
                                <MockField label="Vendedor" value="El del cliente" estado="nuevo" />
                            </MockFrame>
                        }
                        detalle="Se pondrá el vendedor asignado del cliente en la venta."
                    />

                    <ConfigSwitch
                        name="ponerCanal"
                        titulo="Poner Canal"
                        resumen="Al elegir el cliente, su canal de venta asignado se llena solo."
                        maqueta={
                            <MockFrame title="Agregar venta">
                                <MockField label="Canal" value="El del cliente" estado="nuevo" />
                            </MockFrame>
                        }
                        detalle="Se pondrá el canal de venta asignado del cliente en la venta, cotización, pedido y embarque."
                    />

                    <ConfigSwitch
                        name="ponerMetodoDePago"
                        titulo="Poner Metodo de Pago"
                        resumen="Al elegir el cliente, su método de pago se llena solo."
                        maqueta={
                            <MockFrame title="Agregar venta">
                                <MockField label="Método de pago" value="El del cliente" estado="nuevo" />
                            </MockFrame>
                        }
                        detalle="Se pondrá el método de pago asignado del cliente en la venta."
                    />

                    <ConfigSwitch
                        name="avisoVentasPorEntregarVendedor"
                        titulo="Aviso de ventas por entregar al vendedor"
                        resumen="Al entrar a Ventas, el vendedor ve una vez al día sus ventas sin entregar."
                        detalle="Al entrar a Ventas, se le mostrará al usuario (una vez al día) la lista de ventas en las que él es el vendedor y que siguen sin entregar o entregadas parcialmente."
                    />

                    <ConfigSwitch
                        name="duplicarVentas"
                        titulo="Duplicar Ventas"
                        resumen="Agrega el botón para copiar una venta ya hecha."
                        maqueta={
                            <MockFrame title="Detalle de la venta">
                                <MockButton estado="nuevo">Duplicar</MockButton>
                            </MockFrame>
                        }
                        detalle="Se activa la duplicación de ventas. Se recomienda para empresas que hacen ventas parecidas o iguales con frecuencia."
                    />

                    <ConfigSwitch
                        name="mandarIngresoProyectoVentas"
                        titulo="Mandar Ingreso P/Proyecto"
                        resumen="El ingreso se registra al proyecto que trae el insumo de la venta."
                        detalle="Se activa que los ingresos en contabilidad se manden al proyecto del insumo en ventas."
                    />

                    <ConfigSwitch
                        name="ventasNoContables"
                        titulo="Ventas No Contables"
                        resumen="Permite emitir facturas que no generan póliza."
                        detalle="Se podrá emitir una factura de ventas no contables."
                        ultimo
                    />
                </Col>

                <Col xs={24} md={12} xl={8}>
                    <ConfigSwitch
                        name="desactivarSeparacionDescuentoVentas"
                        titulo="Desactivar Separación Descuento Ventas"
                        resumen="Manda a Ingresos el subtotal ya descontado, sin usar las cuentas de descuento."
                        maqueta={
                            <MockDiff
                                antes="El descuento se manda por separado, a cargo de la cuenta de descuento que corresponda al IVA del insumo (general / 0% / exento)."
                                despues="Ingresos recibe el subtotal ya descontado, aunque existan cuentas de descuento configuradas."
                            />
                        }
                        detalle="Si se activa, las ventas nuevas siguen mandando a Ingresos el subtotal ya descontado (como se hace actualmente), aunque existan cuentas de descuento configuradas. Si se desactiva, el descuento se manda por separado (a cargo) a la cuenta de descuento de venta que corresponda según la tasa de IVA del insumo (general / 0% / exento)."
                    />

                    <ConfigSwitch
                        name="separarConceptoIngresoPorInsumo"
                        titulo="Separar Concepto de Ingreso por Producto"
                        resumen="El concepto de cada renglón de ingreso dice qué producto se vendió."
                        maqueta={
                            <MockDiff
                                antes="Venta de Contado FAC-123"
                                despues="Venta de Contado FAC-123 - Playera Talla M"
                            />
                        }
                        detalle="Si se activa, el concepto de cada línea de ingreso en la póliza de venta incluye la descripción del producto/servicio vendido, o la leyenda que se le haya puesto a ese insumo en la venta si tiene una. Si se deja desactivado, el concepto sigue siendo genérico como hasta ahora."
                    />

                    <ConfigSwitch
                        name="desactivarCargaExcelInsumosVentas"
                        titulo="Desactivar Carga de Insumos por Excel"
                        resumen="Quita el botón para subir insumos desde Excel; se capturan renglón por renglón."
                        maqueta={
                            <MockFrame title="Agregar cotización · venta · pedido · embarque">
                                <MockButton estado="oculto">Cargar Excel</MockButton>
                            </MockFrame>
                        }
                        detalle='Si se activa, se oculta el botón "Cargar Excel" para subir insumos desde una hoja de cálculo en Agregar Cotización, Agregar Venta, Agregar Pedido y Agregar Embarque. Los insumos se capturan sólo renglón por renglón.'
                    />

                    <ConfigSwitch
                        name="entregarDisponiblesVenta"
                        titulo="Agregar y Entregar Disponibles"
                        resumen="Agrega un botón en Agregar Venta que entrega sólo lo que hay en inventario y deja el resto pendiente."
                        maqueta={
                            <MockFrame title="Agregar venta">
                                <MockButton estado="nuevo">Agregar y Entregar Disponibles</MockButton>
                            </MockFrame>
                        }
                        detalle='Si se activa, aparece el botón "Agregar y Entregar Disponibles" en Agregar Venta para los usuarios con permiso de entregar insumos. Guarda la venta y entrega de cada renglón lo que haya disponible en su almacén (los lotes se eligen por caducidad). Lo que no alcance queda pendiente para entregarse después desde Entregar Insumos. Permite guardar aunque no haya existencia suficiente. Los renglones con marbetes o agrupaciones se entregan siempre desde Entregar Insumos.'
                    />

                    <ConfigSwitch
                        name="contadoACredito"
                        titulo="Permitir cambiar de Contado a Crédito"
                        resumen="Mientras la venta no tenga ningún pago, se puede pasar a crédito."
                        detalle="Si aún no se paga nada, se puede cambiar de Contado a Crédito."
                    />

                    <ConfigSwitch
                        name="complementoComercioExterior"
                        titulo="Comp. Comercio Exterior"
                        resumen="Habilita el complemento de Comercio Exterior en las facturas de venta."
                        detalle="Se activa el complemento comercio exterior en ventas."
                    />

                    <ConfigSwitch
                        name="complementoEmpresaAlterna"
                        titulo="Empresa Alterna en Documentos"
                        resumen="Permite imprimir remisión, cotización y pedido con los datos de otra empresa. No aplica a facturas."
                        maqueta={
                            <MockDiff
                                labelAntes="Sin la opción"
                                labelDespues="Con la opción"
                                antes="Remisión / cotización / pedido con el nombre, RFC, dirección y logo de la empresa real."
                                despues="Los mismos documentos con la identidad alterna que se configure en el cliente."
                            />
                        }
                        detalle="Permite configurar por cliente una identidad de empresa alterna (nombre, RFC, dirección, logo, correo y teléfono) que sustituye a los datos reales de la empresa en Remisión, Cotización y Pedido. No aplica a Factura."
                    />

                    <ConfigSwitch
                        name="cantidadDefault"
                        titulo="Cantidad Default"
                        resumen="Los insumos entran con cantidad 1 en lugar de quedar vacía."
                        maqueta={
                            <MockFrame title="Agregar insumo a la venta">
                                <MockField label="Cantidad" value="1" estado="nuevo" width={70} />
                            </MockFrame>
                        }
                        detalle="Se activa la cantidad default (1) al agregar un insumo en el módulo de ventas."
                        ultimo
                    />
                </Col>

                <Col xs={24} md={12} xl={8}>
                    <ConfigSwitch
                        name="desactivarBtnCXC"
                        titulo="Desactivar Botón de CXC en Ventas"
                        resumen="Oculta el botón de Cuentas por Cobrar dentro de Ventas."
                        aviso='No se puede activar junto con "Predeterminar CXC (PUE)".'
                        maqueta={
                            <MockFrame title="Detalle de la venta">
                                <MockButton estado="oculto">Cuentas CXC</MockButton>
                            </MockFrame>
                        }
                        detalle='Se desactiva el botón en Ventas de Cuentas CXC. No se puede activar junto con "Predeterminar CXC (PUE)".'
                        afterChange={(checked) => {
                            if (checked) {
                                this.formRef.current.setFieldsValue({ predeterminarCXC: false })
                            }
                        }}
                    />

                    <ConfigSwitch
                        name="regularizarInventarioVentas"
                        titulo="Regularizar inventario"
                        resumen="Permite ajustar el inventario contando las ventas que no se han entregado."
                        detalle="Se activa la opción para regularizar el inventario desde las ventas. Esto permite ir contando las ventas no entregadas para ir regularizando el inventario."
                    />

                    <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                            const regularizarInventarioVentas = getFieldValue('regularizarInventarioVentas')
                            const regularizarInventarioVentasAbajo = getFieldValue('regularizarInventarioVentasAbajo')
                            if (regularizarInventarioVentas) {
                                return (
                                    <ConfigDependientes>
                                        <ConfigSwitch
                                            name="regularizarInventarioVentasAbajo"
                                            titulo="Regularizar hacia abajo"
                                            resumen="Deja registrar menos del mínimo, dando de baja insumos."
                                            detalle="Si se activa se podrá registrar menos del mínimo. Por lo tanto se darán de baja insumos."
                                            ultimo={!regularizarInventarioVentasAbajo}
                                        />
                                        {regularizarInventarioVentasAbajo && (
                                            <ConfigSwitch
                                                name="regularizarInventarioVentasAutomaticoPAC"
                                                titulo="Automatico P.A.C."
                                                resumen="Da de baja los insumos al momento; si no, queda pendiente la orden de productos al costo."
                                                detalle="Si se activa se darán de baja los insumos, sino quedará pendiente la orden de productos al costo."
                                                ultimo
                                            />
                                        )}
                                        <FormItem
                                            name="cuentaAbonoRegularizarInventarioId"
                                            required
                                            marginBottom={8}
                                            label="Cu. Abono Regularizar Inventario"
                                            tooltip='Cuenta contable que se usará para abonar al regularizar el inventario desde las ventas.'
                                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                            style={{ marginTop: 8 }}
                                        >
                                            <SelectItem placeholder="Cuenta Abono">
                                                {this.state.objetoCuentaContable}
                                            </SelectItem>
                                        </FormItem>
                                    </ConfigDependientes>
                                )
                            }
                        }}
                    </FormItem>

                    <ConfigSwitch
                        name="permitirCambiarClienteVenta"
                        titulo="Permitir Cambiar Cliente de Venta"
                        resumen="Agrega el botón para pasar la venta a otro cliente con el mismo RFC."
                        maqueta={
                            <MockFrame title="Detalle de la venta">
                                <MockButton estado="nuevo">Cambiar cliente</MockButton>
                            </MockFrame>
                        }
                        detalle="Habilita el botón para cambiar el cliente de una venta a otro cliente con el mismo RFC."
                    />

                    <ConfigSwitch
                        name="permitirCambiarInsumoVenta"
                        titulo="Permitir Cambiar Insumo en Venta"
                        resumen="Agrega el botón para regresar un insumo al inventario y entregar otro a cambio."
                        maqueta={
                            <MockFrame title="Detalle de la venta">
                                <MockButton estado="nuevo">Cambiar insumo</MockButton>
                            </MockFrame>
                        }
                        detalle="Habilita el botón para regresar un insumo de una venta al inventario y entregar otro insumo distinto a cambio. Solo afecta el inventario y el costo de esa línea; no modifica el insumo facturado ni la cantidad de la venta."
                    />

                    <ConfigSwitch
                        name="permitirBajaLotesReemplazoVentas"
                        titulo="Permitir Dar de Baja Lotes y Reemplazar Códigos"
                        resumen="Agrega 'Dar de baja' en los lotes capturados por error y 'Reemplazar código' en eCommerce."
                        aviso="Cada venta que recibió el lote recibe otro lote disponible y un correo con el código nuevo."
                        maqueta={
                            <MockFrame title="Lotes del insumo · Pedido eCommerce">
                                <MockButton estado="nuevo">Dar de baja</MockButton>
                                <MockButton estado="nuevo">Reemplazar código</MockButton>
                            </MockFrame>
                        }
                        detalle="Habilita en Lotes del insumo el botón 'Dar de baja' para lotes capturados por error (p. ej. duplicados): el lote sale del inventario y a cada venta que lo recibió se le quita, se le entrega otro lote disponible y se le manda el correo con el código nuevo. También habilita 'Reemplazar código' en el detalle del pedido eCommerce."
                    />

                    <ConfigSwitch
                        name="permitirEditarRemisionVenta"
                        titulo="Permitir Editar Remisiones"
                        resumen="Agrega el botón para editar una remisión que todavía no está facturada."
                        aviso="Regenera pólizas y regresa insumos al inventario. No aplica a remisiones facturadas o con pagos."
                        maqueta={
                            <MockFrame title="Remisión no facturada">
                                <MockButton estado="nuevo">Editar remisión</MockButton>
                            </MockFrame>
                        }
                        detalle="Habilita el botón para editar insumos, cantidades, precios y descuentos de una remisión ya creada (no facturada). Si el insumo ya fue entregado, se regresará al inventario y se regenerarán las pólizas de ingreso y de costo/entrega; también se regresará o consumirá la cantidad correspondiente en el pedido/cotización de origen. No aplica a remisiones ya facturadas o con pagos aplicados."
                    />

                    <ConfigSwitch
                        name="permitirDividirVentaPorPartidas"
                        titulo="Permitir Dividir Remisión para Facturar"
                        resumen="Agrega el botón para pasar parte de una remisión sin facturar a una venta copia."
                        aviso="No aplica a remisiones facturadas, con pagos o anticipos aplicados, o ligadas a una factura global."
                        maqueta={
                            <MockFrame title="Remisión no facturada">
                                <MockButton estado="nuevo">Dividir remisión</MockButton>
                            </MockFrame>
                        }
                        detalle="Habilita el botón para dividir una remisión sin facturar en dos: los insumos elegidos se mueven a una venta copia nueva (mismo folio con un sufijo, ej. 'R12 A') para poder facturarla en un momento distinto. No aplica a remisiones ya facturadas, con pagos/anticipos aplicados, o ligadas a una factura global."
                    />

                    <ConfigSwitch
                        name="anticipos"
                        titulo="Anticipos"
                        resumen="Permite emitir una factura de anticipo."
                        detalle="Se podrá emitir una factura de anticipos en ventas. Al activarlo hay que indicar con qué insumo se factura el anticipo y qué porcentaje se propone por defecto."
                    />

                    <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                            if (getFieldValue('anticipos')) {
                                return (
                                    <ConfigDependientes>
                                        <FormItem
                                            name="insumoAnticipoId"
                                            label="Insumo Anticipo"
                                            required
                                            marginBottom={8}
                                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                        >
                                            <SelectInsumosItem
                                                empresaId={this.props.empresaId}
                                                headersToken={this.props.headersToken}
                                                sinBorde
                                                dropdownMatchSelectWidth={600}
                                                width="100%"
                                                placeholder="Insumo Anticipo"
                                            />
                                        </FormItem>
                                        <FormItem
                                            name="cantidadAnticipoDefault"
                                            label="Cantidad Anticipo Default"
                                            required
                                            marginBottom={8}
                                            type="number"
                                            tooltip='Cantidad por defecto que aparecera en la venta de anticipo (en porcentaje %)'
                                            initialValue={50}
                                            max={100}
                                            min={1}
                                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                        >
                                            <InputNumberItem
                                                porcentaje
                                                placeholder="Cantidad Anticipo"
                                            />
                                        </FormItem>
                                    </ConfigDependientes>
                                )
                            }
                        }}
                    </FormItem>

                    <ConfigSwitch
                        name="quitarImpuestosOpcionalVentas"
                        titulo="Quitar Impuestos en Ventas"
                        resumen="Deja quitar los impuestos de una venta en el momento de crearla."
                        detalle="Permite quitar impuestos condicionalmente al crear una venta."
                        ultimo
                    />
                </Col>
            </Row>
        );
    }

    // Ventas › Series y Folios. El interruptor y el catálogo de series. Sólo
    // lo leen pantallas de Ventas (alta de venta, generar factura, refacturar
    // y facturar varias remisiones), por eso vive aquí y no en General. Va en
    // su propia subsección porque el catálogo necesita el ancho completo.
    renderVentasSeries() {
        return (
            <>
                <div style={{ maxWidth: 640 }}>
                    <ConfigSwitch
                        name="complementoSeriesPersonalizadas"
                        titulo="Series y Folios Personalizados"
                        resumen="Permite dar de alta varias series de factura o remisión y elegir cuál usar en cada venta."
                        maqueta={
                            <MockFrame title="Alta de la venta">
                                <MockField label="Serie" value="A / B / FAC" estado="nuevo" width={110} />
                            </MockFrame>
                        }
                        detalle="Permite dar de alta varias series de factura/remisión y elegir manualmente cuál usar en cada venta."
                        afterChange={(checked) =>
                            this.setState({ complementoSeriesPersonalizadas: checked })
                        }
                        ultimo
                    />
                </div>

                {this.state.complementoSeriesPersonalizadas && (
                    <Row gutter={[16, 16]} style={{ marginTop: 12 }}>
                        <Col xs={24} lg={24}>
                            <SeriesVenta
                                empresaId={this.props.empresaId}
                                headersToken={this.props.headersToken}
                            />
                        </Col>
                    </Row>
                )}
            </>
        )
    }

    renderVentasCotizadorInsumo() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="cotizadorPorInsumo"
                    titulo="Cotizador Por Insumo"
                    resumen="Agrega el cotizador por insumo dentro de Ventas."
                    detalle="Se activa el cotizador por insumo en ventas."
                    ultimo
                />
            </div>
        )
    }

    renderVentasPreCotizacion() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="preCotizacionIngenieria"
                    initialValue={false}
                    titulo="Pre Cotización de Ingeniería"
                    resumen="Agrega el módulo de Pre Cotización de Ingeniería."
                    maqueta={
                        <MockFrame title="Menú de Ventas">
                            <MockMenuItem estado="nuevo">Pre Cotización de Ingeniería</MockMenuItem>
                        </MockFrame>
                    }
                    detalle="Activa el módulo de Pre Cotización de Ingeniería."
                    ultimo
                />
            </div>
        )
    }

    renderVentasCotizaciones() {
        return (
            <Row gutter={[28, 0]}>
                <Col xs={24} lg={12}>
                    <ConfigSwitch
                        name="paquetes"
                        titulo="Paquetes"
                        resumen="Permite armar paquetes de insumos en el módulo de ventas."
                        detalle="Se activa la creación de paquetes en el módulo de ventas."
                        ultimo
                    />
                </Col>

                <Col xs={24} lg={12}>
                    <ConfigSwitch
                        name="imprimirImagenesCotizaciones"
                        titulo="Imprimir imagenes en cotizaciones"
                        resumen="El PDF de la cotización incluye la imagen de cada insumo."
                        aviso="Las cotizaciones ya generadas conservan sus imágenes aunque después se desactive."
                        detalle="Se activa la impresión de las imágenes de los insumos en el PDF de la cotización. Las cotizaciones generadas con esta opción mantendrán las imágenes aunque se desactive."
                    />

                    <ConfigSwitch
                        name="editarCotizacionesTerminadas"
                        titulo="Editar Cotizaciones Terminadas"
                        resumen="Deja editar por completo una cotización aunque ya se haya convertido en venta o pedido."
                        maqueta={
                            <MockDiff
                                labelAntes="Bloqueado"
                                labelDespues="Editable"
                                antes="Cotizaciones en Pendiente, Venta o Pedido."
                                despues="Insumos, cantidades, precios, cliente y demás datos, sin bajar de lo ya vendido."
                            />
                        }
                        detalle="Al activar esta casilla se podrán editar las cotizaciones Pendientes, en Venta o en Pedido igual que una vigente. La cantidad de cada insumo no puede quedar por debajo de lo ya vendido o pedido, y la cotización conserva su estado. La venta o el pedido que ya se generaron no cambian."
                    />

                    <ConfigSwitch
                        name="finiquitarCotizaciones"
                        titulo="Finiquitar Cotizaciones"
                        resumen="Deja finiquitar una cotización pendiente para que deje de contar como pendiente."
                        detalle="Al activar esta casilla se podrá finiquitar una cotización pendiente (convertida en parte a venta o pedido) para cerrarla aunque no se haya vendido todo. Lo que faltaba ya no se podrá convertir."
                    />

                    <ConfigSwitch
                        name="formatoRequerimientoCotizaciones"
                        titulo="Formato Único de Requerimiento"
                        resumen="En Agregar Cotización permite descargar el formato de requerimiento del cliente y subirlo lleno para crear los renglones."
                        maqueta={
                            <MockFrame title="Agregar cotización">
                                <MockButton estado="nuevo">Formato vacío</MockButton>
                                <MockButton estado="nuevo">Subir formato</MockButton>
                            </MockFrame>
                        }
                        detalle="Al activar esta casilla aparecen en Agregar Cotización los botones para descargar el Formato Único de Requerimiento vacío y para subirlo lleno por el cliente. Al subirlo, cada ISBN se busca en el código de barras y luego en la clave del insumo, y se crean los renglones con su cantidad; el contacto, las fechas, las direcciones de entrega y el destino de cada renglón quedan en la pestaña Requerimiento. Al guardar la cotización se descarga el formato lleno con el folio, el precio de lista, el descuento y el total."
                    />

                    <ConfigSwitch
                        name="usarColoresCot"
                        titulo="Usar colores en Cotización"
                        resumen="Pinta cada cotización según los días que le faltan para vencer."
                        detalle="Se activa el uso de colores para identificar cuántos días tiene antes de vencer una cotización."
                        ultimo
                    />
                </Col>

                <Col xs={24}>
                    <FormItem shouldUpdate={(prev, curr) => prev.usarColoresCot !== curr.usarColoresCot}
                        style={{ width: "100%" }}
                        noStyle
                    >
                        {({ getFieldValue }) => {
                            if (!getFieldValue("usarColoresCot")) return null;

                            return (
                                <div style={{ padding: "20px", backgroundColor: "#fafafa", borderRadius: "8px", maxWidth: 720, marginTop: 12 }}>
                                    <Text strong>Colores para Cotizaciones (3 niveles)</Text>
                                    <br /><br />
                                    {CONFIG_COTIZACIONES.map((config, index) => (
                                        <Row key={`coti-${index}`} gutter={16} align="middle" style={{ marginBottom: 12 }}>
                                            <FormItem name={["rangosCotizaciones", index, "index"]} initialValue={index} hidden><Input /></FormItem>

                                            <Col span={10}>
                                                <FormItem name={["rangosCotizaciones", index, "nombre"]} label="Etiqueta" margin={false}>
                                                    <InputItem placeholder="Nombre del rango" />
                                                </FormItem>
                                            </Col>

                                            <Col span={6}>
                                                <FormItem name={["rangosCotizaciones", index, "tope"]} label="Tope (Días)" margin={false}>
                                                    {index === 2 ? <Input disabled value="Sin límite" /> : <InputNumberItem min={1} />}
                                                </FormItem>
                                            </Col>

                                            <Col span={8}>
                                                <FormItem name={["rangosCotizaciones", index, "color"]} label="Color" margin={false}>
                                                    <Input type="color" style={{ width: '100%', height: '32px', padding: '2px' }} />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    ))}
                                </div>
                            );
                        }}
                    </FormItem>
                </Col>
            </Row>
        );
    }

    renderVentasPedidos() {
        return (
            <Row gutter={[28, 0]}>
                <Col xs={24} md={12} xl={8}>
                    <ConfigSwitch
                        name="apartarInsumosPedidos"
                        titulo="Apartar Insumos al Agregar Pedido"
                        resumen="Agrega el botón que aparta los insumos disponibles al guardar el pedido."
                        maqueta={
                            <MockFrame title="Agregar pedido">
                                <MockButton estado="nuevo">Agregar y Apartar</MockButton>
                            </MockFrame>
                        }
                        detalle="Muestra el botón 'Agregar y Apartar' al crear un pedido, que aparta insumos disponibles en el mismo paso de guardarlo."
                    />

                    <ConfigSwitch
                        name="pdfApartadoPedido"
                        titulo="PDF de Apartado en Pedidos"
                        resumen="Al apartar insumos en un pedido se muestra un PDF con lo apartado por renglón."
                        detalle="Al apartar insumos en un pedido (al agregarlo o después) muestra un PDF con la cantidad, vendido, requerido, apartado anterior, apartado en ese momento y pendiente de cada renglón."
                    />

                    <ConfigSwitch
                        name="entregarInsumosPedidos"
                        titulo="Entregar Insumos desde Pedido"
                        resumen="Deja entregar insumos desde el pedido, antes de generar la venta."
                        maqueta={
                            <MockFrame title="Lista y detalle del pedido">
                                <MockButton estado="nuevo">Entregar Insumos</MockButton>
                            </MockFrame>
                        }
                        detalle="Permite entregar insumos directo desde un pedido, antes de generar la venta, desde el botón 'Entregar Insumos' en la lista y en el detalle del pedido."
                    />

                    <ConfigSwitch
                        name="activarEtiquetaEntregaPedido"
                        initialValue={false}
                        titulo="Impresión de Etiquetas al Entregar Pedidos"
                        resumen="Agrega el botón “Etiquetas” al entregar insumos sobre pedido, para etiquetas de empaque."
                        maqueta={
                            <MockFrame title="Entregar Insumos sobre Pedido">
                                <MockButton estado="nuevo">Etiquetas</MockButton>
                            </MockFrame>
                        }
                        detalle='Habilita el botón "Etiquetas" en "Entregar Insumos sobre Pedido" para generar etiquetas de empaque. Al activarlo, debajo de esta opción se configura el tamaño, la leyenda y el logo base de la etiqueta.'
                    />

                    <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                            if (!getFieldValue("activarEtiquetaEntregaPedido")) return null;
                            const empresaAlternaActiva = !!getFieldValue("complementoEmpresaAlterna");
                            return (
                                <ConfigDependientes>
                                    <FormItem
                                        label="Ancho Base de Etiqueta (mm)"
                                        name="etiquetaEntregaPedidoAnchoMm"
                                        marginBottom={8}
                                        initialValue={60}
                                        tooltip='Ancho base (en mm, mínimo 60) que se usará por default al generar la etiqueta de empaque en "Entregar Insumos sobre Pedido". Se puede seguir ajustando por etiqueta.'
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <InputNumberItem placeholder="Ancho (mm)" min={60} max={200} />
                                    </FormItem>
                                    <FormItem
                                        label="Leyenda Default de Etiqueta"
                                        name="etiquetaEntregaPedidoLeyenda"
                                        marginBottom={8}
                                        tooltip='Leyenda que aparece por default en la etiqueta de empaque (ej. "Consérvese refrigerado"). Se puede seguir editando por etiqueta.'
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <InputItem placeholder="Ej. Consérvese refrigerado" />
                                    </FormItem>
                                    <FormItem
                                        label="Logo en Etiqueta"
                                        name="etiquetaEntregaPedidoLogo"
                                        marginBottom={8}
                                        initialValue="empresa"
                                        tooltip={empresaAlternaActiva
                                            ? 'Elige si la etiqueta usa el logo de la empresa o el logo alterno del cliente (solo aplica en clientes con "Empresa Alterna" activada).'
                                            : 'Para usar el logo alterno del cliente primero activa "Empresa Alterna en Documentos" en Ventas › General.'}
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <SelectItem placeholder="Logo a usar" disabled={!empresaAlternaActiva}>
                                            <Option value="empresa">Logo de la Empresa</Option>
                                            <Option value="alterno">Logo Alterno del Cliente</Option>
                                        </SelectItem>
                                    </FormItem>
                                </ConfigDependientes>
                            );
                        }}
                    </FormItem>

                    <ConfigSwitch
                        name="generarRequisicionPedidos"
                        titulo="Generar Requisición de Varios Pedidos"
                        resumen="Agrega el botón para requerir juntos los insumos de varios pedidos."
                        maqueta={
                            <MockFrame title="Lista de Pedidos · selección múltiple">
                                <MockButton estado="nuevo">Generar Requisición</MockButton>
                            </MockFrame>
                        }
                        detalle="Muestra el botón 'Generar Requisición' en la lista de Pedidos al seleccionar varios con el selector múltiple, para requerir insumos de todos juntos."
                        ultimo
                    />
                </Col>

                <Col xs={24} md={12} xl={8}>
                    <ConfigSwitch
                        name="importarPedidosIMSS"
                        titulo="Importar Pedidos IMSS"
                        resumen="Lee la orden de suministro del IMSS en Excel y propone un pedido por día."
                        maqueta={
                            <MockFrame title="Pedidos">
                                <MockButton estado="nuevo">Importar Pedidos IMSS</MockButton>
                            </MockFrame>
                        }
                        detalle="Muestra el botón 'Importar Pedidos IMSS' en Pedidos, que lee la orden de suministro del IMSS en Excel y propone un pedido por cada día de la semana."
                    />

                    <ConfigSwitch
                        name="complementoPSWPedidos"
                        titulo="PSW en Pedidos"
                        resumen="Permite subir el PDF de la orden de compra del cliente y capturar su vigencia."
                        detalle="Activa en Pedidos la carga del PDF de la orden de compra del cliente y la captura de su fecha de vigencia."
                    />

                    <ConfigSwitch
                        name="cerrarPedidos"
                        titulo="Cerrar Pedidos"
                        resumen="Deja cerrar un pedido para que nadie lo edite hasta que se reabra."
                        detalle="Al activar esta casilla se podrá cerrar un pedido para que nadie pueda editarlo, a menos que se reabra. Los pedidos cerrados se quedan sin movimiento."
                        ultimo
                    />
                </Col>

                <Col xs={24} md={12} xl={8}>
                    <ConfigSwitch
                        name="finiquitarPedidos"
                        titulo="Finiquitar Pedidos"
                        resumen="Deja finiquitar un pedido para que deje de contar como pendiente."
                        detalle="Al activar esta casilla se podrá finiquitar un pedido pendiente para que deje de contarse como pendiente, aunque no se haya completado."
                    />

                    <ConfigSwitch
                        name="semanaPedidos"
                        titulo="Semana en Pedidos"
                        resumen="Muestra el campo Semana, calculado de la fecha pero editable."
                        maqueta={
                            <MockFrame title="Formulario de pedido">
                                <MockField label="Semana" value="37" estado="nuevo" width={60} />
                            </MockFrame>
                        }
                        detalle="Muestra el campo de Semana en el formulario de pedidos, calculado automáticamente a partir de la fecha del pedido, pero editable."
                        ultimo
                    />
                </Col>
            </Row>
        );
    }

    renderVentasFacturas() {
        return (
            <Row gutter={[28, 0]}>
                <Col xs={24} lg={12}>
                    <ConfigSwitch
                        name="facturarConDevoluciones"
                        titulo="Facturar C/Devoluciones"
                        resumen="Permite facturar una venta que tiene devoluciones."
                        detalle="Se activa que se pueda facturar con devoluciones en ventas."
                    />

                    <ConfigSwitch
                        name="facturaZip"
                        titulo="Factura separada"
                        resumen="Descarga el PDF y el XML sueltos, en lugar de un ZIP."
                        maqueta={
                            <MockDiff
                                antes="factura-A123.zip"
                                despues="factura-A123.pdf   +   factura-A123.xml"
                            />
                        }
                        detalle="Se descargará el archivo de factura y el xml fuera de un archivo zip."
                        ultimo
                    />
                </Col>

                <Col xs={24} lg={12}>
                    <ConfigSwitch
                        name="facturaVariasRemisiones"
                        titulo="Factura de Varias Remisiones"
                        resumen="Permite emitir una sola factura que agrupa varias remisiones."
                        detalle="Se podrá emitir una factura de varias remisiones."
                    />

                    <ConfigSwitch
                        name="facturaFechaAnterior"
                        titulo="Factura Fecha Anterior"
                        resumen="Deja fechar la factura hasta 3 días antes de hoy."
                        detalle="Al generar una factura, se podrá seleccionar una fecha de hasta 3 días antes de la fecha actual."
                        ultimo
                    />
                </Col>
            </Row>
        );
    }

    // Capital Humano. `nomina` decide qué pantallas aparecen dentro del módulo
    // en el menú principal (Puestos, Pre-Nomina, Recibos, Aguinaldo...), así
    // que su lugar es la portada de Capital Humano, no Ventas.
    renderCapitalHumanoGeneral() {
        return this.renderSoloActivacion("nomina", "La nómina");
    }

    // Capital Humano › Pre-Nomina. Las dos opciones sólo las lee la pantalla
    // de Pre-Nomina, que es donde se timbra.
    renderCapitalHumanoPreNomina() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="timbradoDePrueba"
                    initialValue={false}
                    titulo="Timbrado de Prueba"
                    resumen="La nómina se timbra contra el ambiente de pruebas del PAC, no contra el real."
                    aviso="Los CFDI que se generen NO son válidos ante el SAT."
                    maqueta={
                        <MockDiff
                            antes="Botón “Timbrar” · services.sw.com.mx (real)"
                            despues="Botón “Timbrar de Prueba” · services.test.sw.com.mx"
                        />
                    }
                    detalle="Al activar esta casilla la nómina se timbra contra el ambiente de pruebas del PAC (services.test.sw.com.mx) en lugar del real, y el botón cambia a 'Timbrar de Prueba'. Los CFDIs generados NO son válidos ante el SAT. Después de activarla hay que volver a guardar el certificado en Configuración Fiscal para que quede registrado en el ambiente de pruebas."
                />

                <ConfigSwitch
                    name="timbrarNominaHistorica"
                    initialValue={false}
                    titulo="Timbrar Nomina Historica"
                    resumen="Deja timbrar renglones sueltos de una nómina ya pagada en el sistema anterior."
                    aviso="Consume un timbre y emite un CFDI real ante el SAT."
                    detalle="Permite timbrar renglones sueltos de una nómina histórica, que son periodos YA PAGADOS en el sistema anterior y que normalmente no se timbran. Es una salida excepcional para el recibo que quedó sin CFDI en una migración a media año: genera el comprobante y nada más, porque los acumulados ya los cargó el histórico y no se vuelven a aplicar. Úsalo con cuidado: consume un timbre y emite un CFDI real ante el SAT."
                    ultimo
                />
            </div>
        );
    }

    // Capital Humano › Empleados. Lo lee el listado de Empleados (vía Redux) para mostrar el
    // botón "Alta por pasos"; el alta normal no cambia.
    renderCapitalHumanoEmpleados() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="altaEmpleadoPorPasos"
                    initialValue={false}
                    titulo="Alta de Empleados por Pasos"
                    resumen="Agrega un alta guiada que revisa al empleado en el SAT antes de activarlo."
                    maqueta={
                        <MockDiff
                            antes="Botón “Agregar Empleado”"
                            despues="“Agregar Empleado” + “Alta por pasos”"
                        />
                    }
                    detalle="Junto a 'Agregar Empleado' aparece 'Alta por pasos': primero los datos generales, que se cotejan contra el SAT (RFC, nombre, código postal y régimen fiscal) y sin su visto bueno no se avanza; después la pregunta por créditos INFONAVIT y FONACOT; luego los demás datos, y al final una revisión general con la validación de timbrado. Hasta que todo pasa el empleado queda como 'Ficha incompleta' y no entra a ninguna nómina. El alta normal se sigue pudiendo usar. Después de activarlo, vuelve a seleccionar la empresa para que aparezca el botón."
                    ultimo
                />
            </div>
        );
    }

    renderControlAsistencia() {
        return this.renderSoloActivacion("controlAsistencia", "El control de asistencia");
    }

    renderPuntoVentaGeneral() {
        return (
            <div style={{ maxWidth: 640 }}>
                {this.avisoModulo("puntoDeVenta", "El Punto de Venta")}

                <ConfigSwitch
                    name="tikets"
                    titulo="Impresion de Tikets"
                    resumen="Al terminar la venta, el ticket se manda solo a la impresora."
                    aviso="Asegúrese de que la impresora esté conectada y configurada como predeterminada."
                    detalle="Se activa la impresión de tickets. Asegúrese de que la impresora esté conectada y configurada como predeterminada en el equipo."
                />

                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                        const tikets = getFieldValue('tikets')
                        if (tikets) {
                            return (
                                <ConfigDependientes>
                                    <FormItem
                                        label="Impresiones Credito"
                                        name="impresionTicketsCredito"
                                        marginBottom={8}
                                        type="number"
                                        tooltip='Numero de impresiones que se haran en los tikets de ventas a credito'
                                        max={5}
                                        number
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <InputNumberItem placeholder="Imp. Credito" />
                                    </FormItem>
                                    <FormItem
                                        label="Impresiones Contado"
                                        name="impresionTicketsContado"
                                        marginBottom={8}
                                        type="number"
                                        tooltip='Numero de impresiones que se haran en los tikets de ventas al contado'
                                        max={5}
                                        number
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <InputNumberItem placeholder="Imp. Contado" />
                                    </FormItem>
                                </ConfigDependientes>
                            )
                        }
                    }}
                </FormItem>

                <ConfigSwitch
                    name="segundoTicket"
                    titulo="Segundo Ticket"
                    resumen="Imprime una copia extra del ticket, por ejemplo para el área de entrega."
                    detalle="Se activa la impresión de un segundo ticket. Se recomienda para empresas que tienen un lugar de venta y otro de entrega."
                    ultimo
                />
            </div>
        );
    }

    renderConsignaciones() {
        return (
            <div style={{ maxWidth: 640 }}>
                {this.avisoModulo("modulosConsignaciones", "Consignaciones")}

                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                        const modulosConsignaciones = getFieldValue('modulosConsignaciones')
                        if (modulosConsignaciones) {
                            return (
                                <ConfigDependientes>
                                    <FormItem
                                        label="Unidad de Negocio"
                                        marginBottom={8}
                                        name="unidadDeNegocioConsignacionesId"
                                        required
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <SelectItem placeholder="Unidad de Negocio">
                                            {this.state.objetoUniadesDeNegocioFinales}
                                        </SelectItem>
                                    </FormItem>
                                </ConfigDependientes>
                            )
                        }
                    }}
                </FormItem>
            </div>
        );
    }

    renderVentasKiosco() {
        return (
            <div style={{ maxWidth: 640 }}>
                {this.avisoModulo("kiosko", "El Kiosko de Facturación")}

                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                        if (getFieldValue('kiosko')) {
                            return (
                                <ConfigDependientes>
                                    <FormItem
                                        label="Tipo de Cliente"
                                        name="kioskoTipoDeClienteId"
                                        marginBottom={8}
                                        required
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <SelectItem placeholder="Tipo de Cliente">
                                            {this.state.objetoTipoDeCliente}
                                        </SelectItem>
                                    </FormItem>
                                    <FormItem
                                        label="Plazo"
                                        name="kioskoPlazo"
                                        marginBottom={8}
                                        required
                                        tooltip='Todos los plazos son a partir del momento de generacion de la venta'
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <SelectItem placeholder="Plazo">
                                            <Option value={1}>Finales del mes en curso</Option>
                                            <Option value={2}>30 días naturales</Option>
                                            <Option value={3}>15 días naturales</Option>
                                            <Option value={4}>7 días naturales</Option>
                                            <Option value={5}>Finales del mes en curso o 7 dias</Option>
                                        </SelectItem>
                                    </FormItem>
                                </ConfigDependientes>
                            )
                        }
                    }}
                </FormItem>
            </div>
        );
    }

    renderVentasDevoluciones() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="moduloRMA"
                    titulo="Módulo RMA (devoluciones autorizadas)"
                    resumen="Agrega el menú RMA para solicitar, autorizar, recibir e inspeccionar las devoluciones de los clientes antes de emitir la nota de crédito."
                    aviso="Las devoluciones y notas de crédito que se hagan sin RMA siguen funcionando igual. Después de guardar, vuelva a seleccionar la empresa para ver el menú."
                    maqueta={
                        <MockFrame title="Menú Ventas">
                            <MockMenuItem>Devoluciones Venta</MockMenuItem>
                            <MockMenuItem estado="nuevo">RMA</MockMenuItem>
                        </MockFrame>
                    }
                    detalle='Activa el menú "RMA" dentro de Ventas. Un RMA es el expediente de una devolución: se captura a partir de una o varias ventas del cliente, se autoriza según el monto (y el plazo desde la venta), se recibe la mercancía, se inspecciona y al final se resuelve con nota de crédito, reemplazo, reparación o rechazo. Las devoluciones y notas de crédito que se hagan sin RMA siguen funcionando igual. Después de guardar, vuelva a seleccionar la empresa para ver el menú.'
                    ultimo
                />
            </div>
        );
    }

    renderVentasVencimientos() {
        return (
            <div style={{ maxWidth: 680 }}>
                <ConfigSwitch
                    name="quitarFechaVen"
                    titulo="Quitar fecha de vencimiento"
                    resumen="Deja de rellenarse sola la fecha de vencimiento en ventas."
                    detalle="Se quita el auto relleno de la fecha de vencimiento para el módulo de ventas."
                />

                <div className="config-dependientes" style={{ padding: "10px 6px 2px", maxWidth: 260 }}>
                    <FormItem
                        type="number"
                        label="Días predeterminados de vencimiento"
                        name="diasPredetVen"
                        marginBottom={8}
                        tooltip="Ajusta la duración de días que quieres que sean válidas las cotizaciones antes de vencerse."
                        initialValue={30}
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                    >
                        <InputNumberItem
                            min={1}
                            style={{ width: "100%", color: "#000", cursor: "default", backgroundColor: "#f9f9f9" }}
                        />
                    </FormItem>
                </div>

                <ConfigSwitch
                    name="usarColoresVencimiento"
                    titulo="Usar colores para los días de vencimiento (CXC y CXP)"
                    resumen="Pinta los documentos vencidos según los días que llevan de retraso."
                    detalle="Se activa el uso de colores para identificar los documentos vencidos en las tablas vencidas."
                    ultimo
                />

                <FormItem shouldUpdate={(prevValues, currentValues) => prevValues.usarColoresVencimiento !== currentValues.usarColoresVencimiento}
                    style={{ width: "100%" }}
                    noStyle
                >
                    {({ getFieldValue }) => {
                        const usarColores = getFieldValue("usarColoresVencimiento");

                        if (!usarColores) return null;

                        return (
                            <div style={{ padding: "20px", backgroundColor: "#fafafa", borderRadius: "8px", marginTop: "12px", marginBottom: "20px", width: "100%", alignItems: "center", }}>
                                <div style={{ marginBottom: 20, display: "flex", alignItems: "center", gap: "8px" }}>
                                    <Tooltip
                                        title={
                                            <div style={{ fontSize: "12px" }}>
                                                <p><strong>Ejemplo de funcionamiento:</strong></p>
                                                <p>🟢 Rango 1 (Tope 15): Días 0 a 15</p>
                                                <p>🔵 Rango 2 (Tope 30): Días 16 a 30</p>
                                                <p>🟡 Rango 3 (Tope 45): Días 31 a 45</p>
                                                <p>🟠 Rango 4 (Tope 60): Días 46 a 60</p>
                                                <p>🔴 Rango 5 (Sin Límite): Días 61 en adelante</p>
                                            </div>
                                        }
                                        placement="right"
                                    >
                                        <InfoCircleOutlined style={{ color: "#1890ff", cursor: "pointer", fontSize: "16px" }} />
                                    </Tooltip>
                                    <Text type="secondary">
                                        Configura los límites de días para los 5 colores del semáforo.
                                    </Text>
                                </div>

                                {CONFIG_RANGOS.map((config, index) => {
                                    const esUltimo = index === 4;

                                    return (
                                        <Row key={index} gutter={16} align="middle" style={{ marginBottom: 16 }}>
                                            <FormItem
                                                name={["rangosDiasVencimiento", index, "index"]}
                                                initialValue={index}
                                                hidden
                                            >
                                                <Input />
                                            </FormItem>

                                            <Col span={14}>
                                                <FormItem
                                                    name={["rangosDiasVencimiento", index, "nombre"]}
                                                    label="Nombre"
                                                    initialValue={config.label}
                                                    required
                                                    rules={[{ required: true, message: "Falta nombre" }]}
                                                    margin={false}
                                                    style={{ marginBottom: 0 }}
                                                >
                                                    <InputItem placeholder="Nombre del rango" />
                                                </FormItem>
                                            </Col>

                                            <Col span={8}>
                                                {esUltimo ? (
                                                    <>
                                                        <FormItem
                                                            name={["rangosDiasVencimiento", index, "tope"]}
                                                            initialValue={-1}
                                                            hidden
                                                        >
                                                            <Input />
                                                        </FormItem>

                                                        <FormItem
                                                            label="Días"
                                                            style={{ marginBottom: 0 }}
                                                            margin={false}
                                                        >
                                                            <InputItem
                                                                value="Sin límite"
                                                                disabled
                                                                style={{
                                                                    width: "100%",
                                                                    color: "#cf1322",
                                                                    cursor: "default",
                                                                    backgroundColor: "#fff1f0",
                                                                    textAlign: "center"
                                                                }}
                                                            />
                                                        </FormItem>
                                                    </>
                                                ) : (
                                                    <FormItem
                                                        name={["rangosDiasVencimiento", index, "tope"]}
                                                        label="Tope (Días)"
                                                        required
                                                        rules={[{ required: true, message: "Ingresa el tope de días" }]}
                                                        style={{ marginBottom: 0 }}
                                                        margin={false}
                                                    >
                                                        <InputNumberItem
                                                            placeholder="Días"
                                                            min={1}
                                                            style={{ width: "100%" }}
                                                            addonAfter="días"
                                                        />
                                                    </FormItem>
                                                )}
                                            </Col>

                                            <Col span={2} style={{ display: "flex", justifyContent: "center" }}>
                                                <div
                                                    style={{
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: "50%",
                                                        backgroundColor: config.color,
                                                        border: "2px solid #d9d9d9",
                                                        boxShadow: "0 0 4px rgba(0,0,0,0.15)",
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    );
                                })}
                            </div>
                        );
                    }}
                </FormItem>
            </div>
        )
    }
    renderComprasGeneral() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="consultarProveedoresOnline"
                    titulo="Consultar Proveedores Online"
                    resumen="Habilita la consulta de proveedores en línea (Proaliv) desde Compras."
                    detalle="Al activar esta casilla se habilitará la consulta de proveedores en línea (Proaliv) desde el módulo de compras."
                    ultimo
                />
            </div>
        )
    }


    renderComprasRequisiciones() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="separarInsumosRequisicion"
                    titulo="Separar insumos Requisicion"
                    resumen="Al agrupar la requisición, los insumos repetidos se quedan en renglones separados."
                    maqueta={
                        <MockDiff
                            antes="Los insumos iguales se suman en un solo renglón."
                            despues="Cada insumo conserva su propio renglón, aunque se repita."
                        />
                    }
                    detalle="Se activa la separación de insumos en la requisición al agrupar. Si se desactiva, se suman las cantidades de los insumos iguales."
                />

                <ConfigSwitch
                    name="mostrarCostosRequisicion"
                    titulo="Mostrar Costos en Requisicion"
                    resumen="La requisición muestra el costo de cada insumo."
                    maqueta={
                        <MockTable
                            columns={[
                                { label: "Insumo" },
                                { label: "Cant." },
                                { label: "Costo", estado: "nuevo" },
                            ]}
                        />
                    }
                    detalle="Se activa la visualización de los costos en la requisición. Si se desactiva, los costos no se mostrarán."
                />

                <ConfigSwitch
                    name="separarDiasRequisicion"
                    titulo="Separar por dias en Requisicion"
                    resumen="Permite armar la requisición día por día."
                    detalle="Que puedas hacer la requisición por días."
                />

                <ConfigSwitch
                    name="agregarInsumosRequisicion"
                    titulo="Agregar Insumos Requisicion"
                    resumen="Permite agregar insumos en la requisición."
                    detalle="Se activa la separacion de insumos en la requisicion al agrupar. Si se desactiva, se suman las cantidades de los insumos iguales."
                    ultimo
                />
            </div>
        )
    }
    renderComprasWorkbench() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="workbenchRequisiciones"
                    titulo="Workbench de Requisiciones"
                    resumen="Agrega el módulo de Workbench de Requisiciones."
                    maqueta={
                        <MockFrame title="Menú de Compras">
                            <MockMenuItem estado="nuevo">Workbench de Requisiciones</MockMenuItem>
                        </MockFrame>
                    }
                    detalle="Se activa el Módulo de Workbench Requisiciones."
                    ultimo
                />
            </div>
        )
    }
    renderComprasOrdenesCompra() {
        return (
            <Row gutter={[28, 0]}>
                <Col xs={24} lg={12}>
                    <ConfigSwitch
                        name="aprobarOrdenesDeCompra"
                        titulo="Aprobar Ordenes de Compra"
                        resumen="La orden de compra necesita aprobación antes de recibir insumos, factura o finiquitar."
                        aviso="Sólo los usuarios con permiso pueden aprobarlas."
                        detalle="Al activar esta casilla las órdenes de compra requerirán aprobación antes de poder recibir insumos, recibir factura o finiquitar. Solo los usuarios con permiso podrán aprobarlas."
                    />

                    <ConfigSwitch
                        name="editarCostosOrdenDeCompra"
                        titulo="Editar Costos en Orden de Compra"
                        resumen="Deja editar los costos al crear o editar una orden de compra."
                        detalle="Al activar esta casilla se podrán editar los costos al crear o editar una orden de compra."
                    />

                    <ConfigSwitch
                        name="verComoSistemaOCPorDefecto"
                        titulo="Ver Como Sistema Activo por Defecto (OC)"
                        resumen="El interruptor “Ver como sistema” de las órdenes de compra arranca prendido."
                        detalle='Al activar esta casilla, el interruptor "Ver como sistema" de las órdenes de compra iniciará activado por defecto. El usuario puede seguir apagándolo manualmente.'
                    />

                    <ConfigSwitch
                        name="usarColoresPendientesOC"
                        titulo="Usar colores en Órdenes de Compra pendientes"
                        resumen="Pinta cada orden de compra según los días que lleva pendiente."
                        detalle="Se activa el uso de colores para identificar cuántos días lleva pendiente (sin recibir o recibida parcialmente) una orden de compra."
                        ultimo
                    />

                    <FormItem shouldUpdate={(prev, curr) => prev.usarColoresPendientesOC !== curr.usarColoresPendientesOC}
                        style={{ width: "100%" }}
                        noStyle
                    >
                        {({ getFieldValue }) => {
                            if (!getFieldValue("usarColoresPendientesOC")) return null;

                            return (
                                <div style={{ padding: "20px", backgroundColor: "#fafafa", borderRadius: "8px", marginTop: 12, marginBottom: 12 }}>
                                    <Text strong>Colores para Órdenes de Compra pendientes (5 niveles)</Text>
                                    <br /><br />
                                    {CONFIG_OC.map((config, index) => (
                                        <Row key={`oc-${index}`} gutter={16} align="middle" style={{ marginBottom: 12 }}>
                                            <FormItem name={["rangosPendientesOC", index, "index"]} initialValue={index} hidden><Input /></FormItem>

                                            <Col span={10}>
                                                <FormItem name={["rangosPendientesOC", index, "nombre"]} label="Etiqueta" margin={false}>
                                                    <InputItem placeholder="Nombre del rango" />
                                                </FormItem>
                                            </Col>

                                            <Col span={6}>
                                                <FormItem name={["rangosPendientesOC", index, "tope"]} label="Tope (Días)" margin={false}>
                                                    <InputNumberItem min={1} />
                                                </FormItem>
                                            </Col>

                                            <Col span={8}>
                                                <FormItem name={["rangosPendientesOC", index, "color"]} label="Color" margin={false}>
                                                    <Input type="color" style={{ width: '100%', height: '32px', padding: '2px' }} />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    ))}
                                </div>
                            );
                        }}
                    </FormItem>
                </Col>

                <Col xs={24} lg={12}>
                    <ConfigSwitch
                        name="camposFirmaOC"
                        titulo="Campos de Firma en Orden de compra"
                        resumen="El PDF de la orden de compra incluye espacio para firmar quién elaboró y quién autorizó."
                        maqueta={
                            <MockFrame title="PDF de la orden de compra">
                                <MockField label="Elaboró" value="____________" estado="nuevo" width={100} />
                                <MockField label="Autorizó" value="____________" estado="nuevo" width={100} />
                            </MockFrame>
                        }
                        detalle="Se activa un campo en el PDF para agregar la firma de quien elaboró y quien autorizó."
                    />

                    <ConfigSwitch
                        name="imprimirObservacionesOCPorDefecto"
                        titulo="Imprimir Observaciones por Defecto (OC)"
                        resumen="Las órdenes nuevas arrancan con “Imprimir Observaciones” marcado."
                        detalle='Al activar esta casilla, las nuevas órdenes de compra iniciarán con la casilla "Imprimir Observaciones" marcada por defecto.'
                    />

                    <ConfigSwitch
                        name="separacionInsumosSimpleOC"
                        titulo="Separación de insumos simplificada (OC)"
                        resumen="El PDF de separación de insumos sale sin código de barras, solicitante, fecha ni importancia."
                        maqueta={
                            <MockTable
                                columns={[
                                    { label: "Insumo" },
                                    { label: "Cant." },
                                    { label: "Cód. barras", estado: "oculto" },
                                    { label: "Solicitante", estado: "oculto" },
                                    { label: "Importancia", estado: "oculto" },
                                ]}
                            />
                        }
                        detalle="El PDF de separación de insumos de la orden de compra omite código de barras, solicitante, fecha de solicitud e importancia."
                    />

                    <ConfigSwitch
                        name="separacionInsumosPorClienteOC"
                        titulo="Separar PDF de insumos por cliente (OC)"
                        resumen="El PDF de separación de insumos hace un salto de hoja por cada cliente."
                        detalle="El PDF de separación de insumos de la orden de compra hace un salto de hoja por cada cliente."
                    />

                    <ConfigSwitch
                        name="separacionInsumosPorDiaOC"
                        titulo="Separar PDF de insumos por día (OC)"
                        resumen="El PDF de separación de insumos hace un salto de hoja por cada fecha de entrega."
                        detalle="El PDF de separación de insumos de la orden de compra hace un salto de hoja por cada fecha de entrega."
                        ultimo
                    />

                    <FormItem
                        label="Correos en copia (CC) de Órdenes de Compra"
                        margin={false}
                        tooltip='Estos correos se precargan en copia al enviar cualquier orden de compra. El usuario los puede editar en cada envío sin alterar esta lista.'
                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                        style={{ marginTop: 12 }}
                    >
                        <FormInitial.List name="correosCopiaOrdenCompra" initialValue={[]}>
                            {(fields, { add, remove }) => (
                                <>
                                    {fields.map(({ name }, arrayKey) => (
                                        <Row key={name} gutter={8} align="middle">
                                            <Col span={22}>
                                                <FormItem
                                                    name={[name, "correo"]}
                                                    fieldKey={[arrayKey, "correo"]}
                                                    required
                                                    margin={false}
                                                    noStyle
                                                    email
                                                    pattern
                                                >
                                                    <InputItem placeholder="Correo en copia (CC)" />
                                                </FormItem>
                                            </Col>
                                            <Col span={2}>
                                                <div style={{ textAlign: 'center' }}>
                                                    <MinusCircleOutlined onClick={() => remove(name)} />
                                                </div>
                                            </Col>
                                        </Row>
                                    ))}
                                    {fields.length < 5 ? (
                                        <div style={{ marginTop: '5px' }}>
                                            <ButtonItem
                                                blanco={true}
                                                onClick={() => add()}
                                                icon={<PlusOutlined />}
                                                lessTime
                                            >
                                                Agregar copia (CC)
                                            </ButtonItem>
                                        </div>
                                    ) : null}
                                </>
                            )}
                        </FormInitial.List>
                    </FormItem>
                </Col>
            </Row>
        )
    }

    renderComprasFacturas() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="mostrarComplementoPagoFacturas"
                    titulo="Mostrar Complemento de Pago (REP) en Facturas"
                    resumen="Agrega la columna “Con REP / Sin REP” en las tablas de facturas."
                    aviso="Requiere una consulta extra a los pagos; puede hacer más lenta la carga de esas tablas."
                    maqueta={
                        <MockTable
                            columns={[
                                { label: "Folio" },
                                { label: "Proveedor" },
                                { label: "Total" },
                                { label: "Con REP / Sin REP", estado: "nuevo" },
                            ]}
                        />
                    }
                    detalle='Muestra la columna "Con Rep / Sin Rep" en Facturas, Facturas sin Orden de Compra y Facturas de Caja Chica. Requiere una consulta adicional a los pagos, por lo que puede hacer más lenta la carga de esas tablas.'
                />

                <ConfigSwitch
                    name="vencimientoDesdeRecepcionFactura"
                    titulo="Vencimiento desde la Fecha de Recepción"
                    resumen="Al recibir una factura de proveedor se captura la Fecha de Recepción y el vencimiento se calcula desde ella, no desde la fecha de la factura."
                    aviso="Después de guardar, vuelva a seleccionar la empresa para que se aplique."
                    maqueta={
                        <MockFrame title="Recibir Factura">
                            <MockField label="Fecha de Factura" value="01/11/2026" width={80} />
                            <MockField label="Fecha de Recepción" value="05/11/2026" estado="nuevo" width={80} />
                            <MockField label="Días de crédito" value="30" width={50} />
                            <MockField label="Fecha P. Pago" value="05/12/2026" width={80} />
                        </MockFrame>
                    }
                    detalle='Al capturar una Factura sin Orden de Compra (manual o con XML) o al Recibir Factura de una o varias Órdenes de Compra aparece el campo "Fecha de Recepción", que por omisión es el día de hoy. La Fecha Probable de Pago, que también es la fecha de vencimiento, se calcula como Fecha de Recepción + Días de Crédito; si se cambia la Fecha de Recepción o los Días de Crédito se recalcula, y cambiar la Fecha de Factura ya no la mueve. En Importar Facturas XML Masivo y Captura Rápida de Gastos la Fecha de Recepción es el día de la importación. En "Editar Datos Factura" se puede corregir la Fecha de Recepción de una factura ya capturada y se recalculan la Fecha Probable de Pago y la Fecha de Vencimiento. Las facturas de Caja Chica no cambian. Después de guardar, vuelva a seleccionar la empresa para que se aplique.'
                    ultimo
                />
            </div>
        )
    }

    renderComprasComodato() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="comodatoPorDefectoProveedor"
                    titulo="Comodato por Defecto (Proveedor)"
                    resumen="Al elegir un proveedor, la orden de compra se marca como comodato sola."
                    detalle="Al activar esta casilla, las órdenes de compra se marcarán como comodato por defecto al seleccionar un proveedor."
                />

                <ConfigSwitch
                    name="comodatoFechaEntregaObligatoria"
                    titulo="Fecha de Entrega Obligatoria (Comodato)"
                    resumen="En una Orden de Comodato la Fecha de Entrega es obligatoria y acepta fechas pasadas."
                    detalle="Al activar esta casilla, la Fecha de Entrega será obligatoria al capturar una Orden de Comodato y podrá elegirse cualquier fecha, incluyendo fechas pasadas."
                    ultimo
                />
            </div>
        )
    }

    renderComprasDevoluciones() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="moduloRMACompras"
                    titulo="Módulo RMA de compras (devoluciones a proveedores)"
                    resumen="Agrega el menú RMA Compras para pedir al proveedor la autorización de una devolución, enviarle la mercancía y darle seguimiento hasta que la resuelva."
                    aviso="Las devoluciones de compra que se hagan sin RMA siguen funcionando igual. Después de guardar, vuelva a seleccionar la empresa para ver el menú."
                    maqueta={
                        <MockFrame title="Menú Compras">
                            <MockMenuItem>Devoluciones Compra</MockMenuItem>
                            <MockMenuItem estado="nuevo">RMA Compras</MockMenuItem>
                        </MockFrame>
                    }
                    detalle='Activa el menú "RMA Compras" dentro de Compras. Un RMA de compra es el expediente de una devolución a proveedor: se captura a partir de una o varias facturas o remisiones del proveedor, se le manda la solicitud en PDF, se registra su número de autorización, se le envía la mercancía y al final se resuelve con nota de crédito, reemplazo, reparación o rechazo. Las devoluciones de compra que se hagan sin RMA siguen funcionando igual. Después de guardar, vuelva a seleccionar la empresa para ver el menú.'
                    ultimo
                />
            </div>
        );
    }

    renderComprasProrrateos() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="prorrateoDesCostos"
                    titulo="Prorrateo de costos"
                    resumen="Habilita el prorrateo de costos en compras."
                    detalle="Al activar esta casilla se habilitará el prorrateo de costos en compras. Hay que indicar a qué cuenta contable se lleva."
                    ultimo
                />

                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                        if (getFieldValue('prorrateoDesCostos')) {
                            return (
                                <ConfigDependientes>
                                    <FormItem
                                        label="Cuenta contable prorrateo"
                                        name="cuentaContableProrrateoId"
                                        marginBottom={8}
                                        required
                                        tooltip='Cuenta contable que se usará para el prorrateo de costos en compras.'
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <SelectItem placeholder="Cuenta contable">
                                            {this.state.objetoCuentaContable}
                                        </SelectItem>
                                    </FormItem>
                                </ConfigDependientes>
                            )
                        }
                    }}
                </FormItem>
            </div>
        )
    }

    renderSectionEnvios() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="envios"
                    initialValue={false}
                    titulo="Activar Envíos"
                    resumen="Agrega los envíos dentro de Ventas y habilita la carta porte."
                    detalle="Al activar esta casilla se activan los envíos en el apartado de las ventas, también proporciona la carta porte. Hay que indicar en qué unidad se mide el peso."
                />

                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                        if (getFieldValue('envios')) {
                            return (
                                <ConfigDependientes>
                                    <FormItem
                                        name="unidadPesoId"
                                        label="Unidad Peso"
                                        required
                                        marginBottom={8}
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <SelectItem placeholder="Unidad Peso">
                                            {this.state.objetoUnidadesPeso}
                                        </SelectItem>
                                    </FormItem>
                                </ConfigDependientes>
                            )
                        }
                    }}
                </FormItem>

                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                        if (getFieldValue('envios')) {
                            return (
                                <ConfigDependientes>
                                    <ConfigSwitch
                                        name="fletes"
                                        initialValue={false}
                                        titulo="Activar Fletes"
                                        resumen="Habilita los envíos que hace un tercero, con insumos fleteados en la venta y su carta porte."
                                        detalle="Al activar esta casilla se activan los envíos realizados a terceros, proporciona insumos fleteados en las ventas, también proporciona la carta porte."
                                        ultimo
                                    />
                                </ConfigDependientes>
                            )
                        }
                    }}
                </FormItem>
            </div>
        )
    }

    renderSectionGeneral() {
        return (
            <>
                <Row gutter={[28, 0]}>
                    <Col xs={24} lg={12}>
                        {this.isEmpresaAutorizada() ? (
                            <ConfigSwitch
                                name="activarEspejo"
                                initialValue={false}
                                titulo="Activar Espejo"
                                resumen="Habilita el espejo de la empresa."
                            />
                        ) : null}

                        <ConfigSwitch
                            name="autorizacionesRapidas"
                            initialValue={false}
                            titulo="Autorizaciones Rápidas"
                            resumen="Un usuario sin permiso puede pedirle autorización a otro con un código o de forma remota."
                            detalle="Permite que un usuario sin permiso (para modificar precio, descuento, lista de precios o aprobar una orden de compra) pida autorización con código o de forma remota a otro usuario configurado como autorizador."
                            ultimo
                        />

                        {/* Buscador del Menú
                        <ConfigSwitch
                            name="buscadorMenu"
                            initialValue={true}
                            titulo="Buscador del Menú"
                            resumen="Pone un campo de búsqueda arriba del menú lateral."
                            detalle="Muestra un campo de búsqueda arriba del menú lateral para encontrar rápidamente un módulo por su nombre."
                        />
                        */}
                    </Col>

                    <Col xs={24} lg={12}>
                        <div className="config-dependientes" style={{ padding: "2px 6px", maxWidth: 260 }}>
                            <FormItem
                                label="Decimales Empresa"
                                name="decimalesEmpresa"
                                marginBottom={8}
                                initialValue={null}
                                tooltip='Número de decimales utilizados en la empresa (entre 1 y 6).'
                                labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                            >
                                <SelectItem placeholder="Decimales Empresa" allowClear>
                                    <Option value={1}>1 decimal</Option>
                                    <Option value={2}>2 decimales</Option>
                                    <Option value={3}>3 decimales</Option>
                                    <Option value={4}>4 decimales</Option>
                                    <Option value={5}>5 decimales</Option>
                                    <Option value={6}>6 decimales</Option>
                                </SelectItem>
                            </FormItem>
                        </div>
                    </Col>
                </Row>

                {this.renderDivider('Adendas')}
                <Row gutter={[28, 0]}>
                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name="complementoDetallista"
                            initialValue={false}
                            titulo="Adenda Liverpool"
                            resumen="Habilita el complemento detallista para facturar a Liverpool."
                            ultimo
                        />
                    </Col>
                </Row>
            </>
        )
    }

    /* ─────────── Portadas de los módulos que se dan de alta aquí ─────────── */

    renderWms() {
        return this.renderSoloActivacion("moduloWms", "El módulo WMS");
    }

    renderActivosFijos() {
        return this.renderSoloActivacion("moduloActivosFijos", "El módulo de Activos Fijos");
    }

    renderMantenimiento() {
        return this.renderSoloActivacion("moduloCMMS", "El módulo CMMS");
    }

    renderProduccion() {
        return (
            <div style={{ maxWidth: 640 }}>
                <FormItem
                    label="Unidad de tiempo"
                    name="unidadTiempoProduccion"
                    marginBottom={8}
                    initialValue="minutos"
                    tooltip='Unidad en la que se captura y se muestra el tiempo ciclo de las matrices, la planeación de órdenes de producción y el tiempo de trabajo al mover piezas. En horas, 1 = 60 minutos.'
                    labelCol={{ span: 24 }} wrapperCol={{ span: 12 }} labelAlign="left"
                >
                    <SelectItem placeholder="Unidad de tiempo">
                        <Option value="minutos">Minutos</Option>
                        <Option value="horas">Horas</Option>
                    </SelectItem>
                </FormItem>

                <ConfigSwitch
                    name="arrastrarDesfaseProduccionEntreDias"
                    initialValue={false}
                    titulo="Arrastrar el atraso de un día al siguiente"
                    resumen="En la planeación, el desfase de una orden se sigue recorriendo a los días siguientes."
                    aviso="Se recomienda dejarlo apagado: cada día arranca en su horario planeado."
                    maqueta={
                        <MockDiff
                            labelAntes="Apagado"
                            labelDespues="Encendido"
                            antes="El recorrido se corta al cambiar de día: cada día arranca en su horario planeado."
                            despues="El desfase se sigue arrastrando a los días siguientes, como una línea continua."
                        />
                    }
                    detalle='En la planeación, el atraso o adelanto de una orden recorre las órdenes que siguen. Apagado (recomendado), ese recorrido se corta al cambiar de día: cada día arranca en su horario planeado. Encendido, el desfase se sigue arrastrando a los días siguientes, como una línea continua.'
                />

                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) =>
                        getFieldValue("preCotizacionIngenieria") ? (
                            <>
                                <ConfigSwitch
                                    name="ordenesMaquila"
                                    initialValue={false}
                                    titulo="Órdenes de maquila"
                                    resumen="Todas las órdenes de producción se manejan en modo maquila."
                                    detalle="Las órdenes usan el flujo simple Pendiente → En proceso → Terminado, sin lotes, merma ni calidad, y el módulo se nombra Órdenes de Maquila. Solo se puede cambiar si no hay órdenes abiertas."
                                    ultimo={!getFieldValue("ordenesMaquila")}
                                />
                                {getFieldValue("ordenesMaquila") && (
                                    <ConfigSwitch
                                        name="producirSinInventario"
                                        initialValue={false}
                                        titulo="Producir sin inventario"
                                        resumen="Al mover piezas solo se informa el material que se ocupa, sin validarlo ni descontarlo."
                                        detalle="Las órdenes no se detienen por falta de material ni lo descuentan del inventario; el producto terminado sí entra al inventario. Solo se puede cambiar si no hay órdenes abiertas."
                                        ultimo
                                    />
                                )}
                            </>
                        ) : null
                    }
                </FormItem>
            </div>
        )
    }

    renderHotel() {
        return this.renderSoloActivacion("moduloHoteleria", "El módulo de Hotelería");
    }

    renderCrm() {
        return this.renderSoloActivacion("crm", "El CRM");
    }

    renderMedico() {
        return (
            <div style={{ maxWidth: 640 }}>
                {this.avisoModulo("equipoMedico", "El complemento de equipo médico")}

                <FormItem
                    noStyle
                    shouldUpdate={(prevValues, currentValues) => prevValues.equipoMedico !== currentValues.equipoMedico}
                >
                    {({ getFieldValue }) => {
                        if (!getFieldValue("equipoMedico")) return null;

                        return (
                            <ConfigDependientes>
                                <ConfigSwitch
                                    name="docObligatorio"
                                    initialValue={false}
                                    titulo="Doctor obligatorio"
                                    resumen="No deja guardar una venta sin indicar el doctor."
                                    detalle="Al activar esta casilla se activa que sea obligatorio colocar un Doctor al realizar una venta."
                                    ultimo
                                />
                            </ConfigDependientes>
                        );
                    }}
                </FormItem>
            </div>
        )
    }

    renderMezcal() {
        return this.renderSoloActivacion("modulosMezcal", "El módulo de Mezcal");
    }

    renderProveedoresEvaluacion() {
        return this.renderSoloActivacion("evaluacionProveedores", "La evaluación de proveedores");
    }

    renderClientesEscuela() {
        return this.renderSoloActivacion("escuela", "El módulo de Escuela");
    }

    renderVentasEmbarques() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="embarques"
                    initialValue={false}
                    titulo="Activar Embarques"
                    resumen="Agrega el módulo de Embarques a la empresa."
                    maqueta={
                        <MockFrame title="Menú principal">
                            <MockMenuItem estado="nuevo">Embarques</MockMenuItem>
                        </MockFrame>
                    }
                    detalle="Al activar esta casilla se activa el módulo de Embarques en la empresa."
                    ultimo
                />
            </div>
        )
    }

    renderInventarioMovimientos() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="mostrarPdfMovimientosInventario"
                    initialValue={false}
                    titulo="Mostrar PDF de Movimientos de Inventario"
                    resumen="Al generar un movimiento de inventario se abre solo su PDF."
                    detalle="Se activa que al generar movimientos de inventario se muestre automáticamente el PDF de los movimientos."
                    ultimo
                />
            </div>
        )
    }

    // Finanzas › Polizas. En el menú principal la pantalla de Pólizas vive
    // bajo Finanzas; Contabilidad sólo tiene "Tipo de Polizas".
    renderFinanzasPolizas() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="editarTodasLasPolizas"
                    titulo="Editar Todas las Pólizas"
                    resumen="Deja editar cualquier póliza, no sólo las manuales."
                    aviso="Incluye las pólizas que genera el sistema a partir de ventas, compras y pagos."
                    maqueta={
                        <MockDiff
                            antes="Sólo se pueden editar las pólizas capturadas a mano."
                            despues="Se puede editar cualquier póliza, incluidas las automáticas."
                        />
                    }
                    detalle="Al activar esta casilla se podrá editar cualquier póliza, incluidas las generadas automáticamente, no solo las manuales."
                />

                <ConfigSwitch
                    name="verPolizaAlRealizarMovimiento"
                    titulo="Ver Póliza al Realizar Movimiento"
                    resumen="Al terminar un movimiento se abren solas las pólizas que generó."
                    aviso="Sólo aplica a los usuarios con el permiso 'Ver Poliza Al Realizar Movimiento'."
                    detalle="Al activar esta casilla, al terminar un movimiento se abre automáticamente la hoja con las pólizas que generó. Aplica sólo a los usuarios que tengan el permiso 'Ver Poliza Al Realizar Movimiento'."
                    ultimo
                />
            </div>
        )
    }

    // Calidad. Cada opción muestra u oculta un campo del módulo; el nombre del
    // campo va en el renglón y la maqueta enseña dónde aparece, para no tener
    // que abrir el programa a ver qué cambió.
    renderSectionCalidad() {
        return (
            <>
                <div style={{ maxWidth: 640 }}>
                    {this.avisoModulo("moduloCalidad", "El módulo de Calidad")}
                </div>

                {this.renderDivider('Programa')}
                <Row gutter={[28, 0]}>
                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name={['camposCalidad', 'programa', 'duracionEstimada']}
                            titulo="Duración estimada"
                            resumen="El programa pide cuánto se espera que dure."
                            maqueta={
                                <MockFrame title="Programa">
                                    <MockField label="Duración estimada" value="8 h" estado="nuevo" width={80} />
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar el campo de duración estimada en el programa."
                            ultimo
                        />
                    </Col>

                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name={['camposCalidad', 'programa', 'metadatos']}
                            titulo="Metadatos (tipo de industria)"
                            resumen="El programa pide sus metadatos, como el tipo de industria."
                            maqueta={
                                <MockFrame title="Programa">
                                    <MockField label="Tipo de industria" value="Alimentos" estado="nuevo" width={100} />
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar los metadatos del programa."
                            ultimo
                        />
                    </Col>
                </Row>

                {this.renderDivider('Proceso')}
                <Row gutter={[28, 0]}>
                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name={['camposCalidad', 'proceso', 'toleranciaRetardo']}
                            titulo="Tolerancia de retardo"
                            resumen="El proceso pide cuánto retardo se le tolera."
                            maqueta={
                                <MockFrame title="Proceso">
                                    <MockField label="Tolerancia de retardo" value="15 min" estado="nuevo" width={80} />
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar el campo de tolerancia de retardo en el proceso."
                        />

                        <ConfigSwitch
                            name={['camposCalidad', 'proceso', 'requireAprobacion']}
                            titulo="Requiere aprobación"
                            resumen="El proceso pide si hay que aprobarlo para darlo por cerrado."
                            maqueta={
                                <MockFrame title="Proceso">
                                    <MockField label="Requiere aprobación" value="Sí" estado="nuevo" width={70} />
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar el campo de requiere aprobación en el proceso."
                        />

                        <ConfigSwitch
                            name={['camposCalidad', 'proceso', 'requirePresencia']}
                            titulo="Requiere presencia física"
                            resumen="El proceso pide si hay que estar en sitio para ejecutarlo."
                            maqueta={
                                <MockFrame title="Proceso">
                                    <MockField label="Requiere presencia física" value="Sí" estado="nuevo" width={70} />
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar el campo de requiere presencia física en el proceso."
                            ultimo
                        />
                    </Col>

                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name={['camposCalidad', 'proceso', 'duracionEstimada']}
                            titulo="Duración estimada"
                            resumen="El proceso pide cuánto se espera que dure."
                            maqueta={
                                <MockFrame title="Proceso">
                                    <MockField label="Duración estimada" value="2 h" estado="nuevo" width={80} />
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar el campo de duración estimada en el proceso."
                        />

                        <ConfigSwitch
                            name={['camposCalidad', 'proceso', 'metadatos']}
                            titulo="Metadatos (tipo actividad, riesgo, etiquetas)"
                            resumen="El proceso pide su tipo de actividad, su riesgo y sus etiquetas."
                            maqueta={
                                <MockFrame title="Proceso">
                                    <MockField label="Tipo de actividad" value="Inspección" estado="nuevo" width={90} />
                                    <MockField label="Riesgo" value="Medio" estado="nuevo" width={70} />
                                    <MockField label="Etiquetas" value="SGC, ISO" estado="nuevo" width={90} />
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar los metadatos del proceso: tipo de actividad, riesgo y etiquetas."
                            ultimo
                        />
                    </Col>
                </Row>

                {this.renderDivider('Punto')}
                <Row gutter={[28, 0]}>
                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name={['camposCalidad', 'punto', 'pasos']}
                            titulo="Pasos del procedimiento"
                            resumen="El punto incluye la lista de pasos del procedimiento."
                            maqueta={
                                <MockFrame title="Punto">
                                    <MockMenuItem estado="nuevo">Pasos del procedimiento</MockMenuItem>
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar la sección de pasos del procedimiento en el punto."
                        />

                        <ConfigSwitch
                            name={['camposCalidad', 'punto', 'criterioTolerancia']}
                            titulo="Criterios — columna Tolerancia"
                            resumen="La tabla de criterios trae la columna Tolerancia."
                            maqueta={
                                <MockTable
                                    columns={[
                                        { label: "Criterio" },
                                        { label: "Valor esperado" },
                                        { label: "Tolerancia", estado: "nuevo" },
                                    ]}
                                />
                            }
                            detalle="Mostrar u ocultar la columna de tolerancia en la tabla de criterios del punto."
                            ultimo
                        />
                    </Col>

                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name={['camposCalidad', 'punto', 'criterioReferencias']}
                            titulo="Criterios — sección Referencias"
                            resumen="Los criterios incluyen su sección de referencias."
                            maqueta={
                                <MockFrame title="Criterios del punto">
                                    <MockMenuItem estado="nuevo">Referencias</MockMenuItem>
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar la sección de referencias en los criterios del punto."
                        />

                        <ConfigSwitch
                            name={['camposCalidad', 'punto', 'riesgos']}
                            titulo="Sección de Riesgos"
                            resumen="El punto incluye su sección de riesgos."
                            maqueta={
                                <MockFrame title="Punto">
                                    <MockMenuItem estado="nuevo">Riesgos</MockMenuItem>
                                </MockFrame>
                            }
                            detalle="Mostrar u ocultar la sección de riesgos en el punto."
                            ultimo
                        />
                    </Col>
                </Row>
            </>
        );
    }
    renderConteos() {
        return (
            <div style={{ maxWidth: 700 }}>
                <ConfigSwitch
                    name="conteos"
                    initialValue={false}
                    titulo="Activar Conteos"
                    resumen="Habilita los conteos de inventario (inventario cíclico)."
                    detalle="Al activar esta casilla se activan los conteos en el inventario (Inventario Cíclico)."
                    ultimo
                />
            </div>
        )
    }

    // Inventario › Lotes. Los colores del semáforo de caducidad. Sólo se
    // muestran si Insumos tiene prendido "Lotes y Caducidades".
    renderInventarioLotes() {
        return (
            <div style={{ maxWidth: 700 }}>
                <FormItem shouldUpdate={(prev, curr) => prev.usarColoresLotes !== curr.usarColoresLotes}
                    style={{ width: "100%" }}
                    noStyle
                >
                    {({ getFieldValue }) => {
                        const usarColoresLotes = getFieldValue("usarColoresLotes");
                        const lotesCaducidades = getFieldValue("lotesCaducidades");

                        if (!lotesCaducidades) return null;

                        let objectReturn = [
                            (
                                <ConfigSwitch
                                    key="usarColoresLotes"
                                    name="usarColoresLotes"
                                    titulo="Usar colores en Lotes"
                                    resumen="Pinta cada lote según los días que le faltan para vencer."
                                    detalle="Se activa el uso de colores para identificar cuántos días tiene antes de vencer un lote."
                                    ultimo
                                />
                            )
                        ]

                        if (usarColoresLotes) {
                            objectReturn.push(
                                <div key="coloresLotes" style={{ padding: "20px", backgroundColor: "#fafafa", borderRadius: "8px", marginTop: 12 }}>
                                    <Text strong>Colores para Lotes (5 niveles)</Text>
                                    <br /><br />
                                    {CONFIG_LOTES.map((config, index) => (
                                        <Row key={`lote-${index}`} gutter={16} align="middle" style={{ marginBottom: 12 }}>
                                            <FormItem name={["rangosLotes", index, "index"]} initialValue={index} hidden><Input /></FormItem>

                                            <Col span={10}>
                                                <FormItem name={["rangosLotes", index, "nombre"]} label="Etiqueta" margin={false}>
                                                    <InputItem placeholder="Nombre del rango" />
                                                </FormItem>
                                            </Col>

                                            <Col span={6}>
                                                <FormItem name={["rangosLotes", index, "tope"]} label="Tope (Días)" margin={false}>
                                                    {index === 4 ? <InputNumberItem value={1} disabled /> : <InputNumberItem min={1} />}
                                                </FormItem>
                                            </Col>

                                            <Col span={8}>
                                                <FormItem name={["rangosLotes", index, "color"]} label="Color" margin={false}>
                                                    <Input type="color" style={{ width: '100%', height: '32px', padding: '2px' }} />
                                                </FormItem>
                                            </Col>
                                        </Row>
                                    ))}
                                </div>
                            )
                        }

                        return objectReturn;
                    }}
                </FormItem>
            </div>
        )
    }

    renderSectionInsumos() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="lotesCaducidades"
                    initialValue={false}
                    titulo="Activar Lotes y Caducidades"
                    resumen="Habilita lotes y fechas de caducidad en los productos."
                    detalle="Al activar esta casilla se activan los lotes y caducidades en los productos."
                />

                <ConfigSwitch
                    name="filtrosAvanzadosInsumos"
                    initialValue={false}
                    titulo="Filtros avanzados de insumos"
                    resumen="Permite filtrar insumos por atributos propios, como Voltaje, Color o Material."
                    detalle="Activa el módulo de categorías y valores dinámicos para filtrar insumos por atributos custom (ej. Voltaje, Color, Material)."
                />

                <ConfigSwitch
                    name="insumosXCliente"
                    initialValue={false}
                    titulo="Activar Insumos x Cliente"
                    resumen="Permite darle a cada cliente nombres alternos y limitar sus ventas a esos insumos."
                    detalle="Permite configurar, por cliente, un nombre alterno para sus insumos y restringir las ventas a solo esos insumos."
                    ultimo
                />
            </div>
        )
    }

    renderCobranzaGeneral() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="programarRecordatorioCxC"
                    titulo="Programar Recordatorios de Cobros"
                    resumen="Manda recordatorios por correo a los clientes con cuentas por cobrar vencidas."
                    detalle="Se activa la programación de recordatorios mediante correo electrónico para los cobros a clientes que tengan cuentas por cobrar vencidas."
                    ultimo
                />
            </div>
        )
    }

    renderCobranzaCuentasPorCobrar() {
        return (
            <>
                <Row gutter={[28, 0]}>
                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name="factorajeFinancieroCXC"
                            titulo="Factoraje Financiero"
                            resumen="Habilita el factoraje financiero en Cuentas CXC."
                            detalle="Se activa el factoraje financiero en Cuentas CXC."
                        />

                        <ConfigSwitch
                            name="cuentasIncobrables"
                            titulo="Cuentas Incobrables"
                            resumen="Permite marcar una cuenta por cobrar como incobrable."
                            detalle="Se activa que las CXC se puedan hacer incobrables."
                            ultimo
                        />
                    </Col>

                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name="cuentasAjusteCentavosCxC"
                            titulo="Cuentas Ajuste Centavos CxC"
                            resumen="Permite quitar la diferencia de centavos al cobrar."
                            detalle="Se activa que las CXC se puedan quitar la diferencia de centavos."
                        />

                        <ConfigSwitch
                            name="desactivarSeparacionMovimientosCobranza"
                            titulo="Desactivar Separación de Movimientos por Factura"
                            resumen="Registra un solo movimiento con el monto total, en lugar de uno por cada venta cobrada."
                            maqueta={
                                <MockDiff
                                    antes="Un cargo o abono por cada venta cobrada, con su propio monto."
                                    despues="Un solo movimiento con el monto total del pago."
                                />
                            }
                            detalle="Si se desactiva esta casilla, al cobrar varias ventas de un cliente en un mismo pago, el cargo o abono a la cuenta del cliente se registra por separado para cada factura/venta (con su propio monto), para poder identificar en la póliza cuánto correspondió a cada una. Si se activa, se registra un solo movimiento con el monto total, como funciona actualmente."
                            ultimo
                        />
                    </Col>
                </Row>
            </>
        )
    }

    renderSectionDropshipping() {
        return (
            <>
                <DynamicCardForm
                    title="DROPSHIPPING URREA"
                    style={{
                        width: "100%",
                        maxWidth: 400
                    }}
                >
                    <FormItem
                        label="Habilitar API de URREA"
                        name="apiURREA"
                        margin
                        valuePropName="checked"
                        tooltip='Se activa la conexión con la base de datos de URREA para poder consultar la ficha técnica de los Insumos.'
                        labelCol={{ span: 16 }} wrapperCol={{ span: 4 }}
                    >
                        <SwitchItem
                            disabled
                            onChange={(value) => {
                                if (!value) {
                                    this.formRef.current.setFieldsValue({
                                        usuarioURREA: "",
                                        passwordURREA: "",
                                    });
                                }
                                this.setState({ apiURREA: value });
                            }}
                        ></SwitchItem>
                    </FormItem>
                    {this.state.apiURREA ? (
                        <>
                            <FormItem
                                label="Usuario"
                                name="usuarioURREA"
                                margin
                                tooltip="Ingrese su usuario"
                            >
                                <InputItem placeholder="Usuario URREA"></InputItem>
                            </FormItem>
                            <FormItem
                                label="Contraseña"
                                name="passwordURREA"
                                margin
                                tooltip="Ingrese su contraseña asociada a su usuario de URREA"
                            >
                                <Input.Password
                                    prefix={<LockOutlined className="site-form-item-icon" />}
                                    placeholder="Contraseña"
                                    maxLength={30}
                                />
                            </FormItem>
                        </>
                    ) : null}

                </DynamicCardForm>
                <DynamicCardForm
                    title="Aplicación Móvil"
                    style={{
                        width: "100%",
                        maxWidth: 400
                    }}
                >
                    {this.avisoModulo("appMovil", "La aplicación móvil")}
                    <FormItem shouldUpdate={(prev, cur) => prev.appMovil !== cur.appMovil} noStyle>
                        {({ getFieldValue }) => (
                            <FormItem
                                label="Checada remota desde la app"
                                name="checadaRemota"
                                margin
                                valuePropName="checked"
                                tooltip='Permite que los empleados habilitados registren su entrada y salida desde la app, solo dentro de los perímetros de checada. Requiere la aplicación móvil activa.'
                                labelCol={{ span: 16 }} wrapperCol={{ span: 4 }}
                            >
                                <Switch disabled={!getFieldValue("appMovil") || this.bloqueado("checadaRemota", getFieldValue)} />
                            </FormItem>
                        )}
                    </FormItem>
                    <FormItem shouldUpdate={(prev, cur) => prev.appMovil !== cur.appMovil || prev.checadaRemota !== cur.checadaRemota} noStyle>
                        {({ getFieldValue }) => (
                            <FormItem
                                label="Verificación facial al checar"
                                name="verificacionFacial"
                                margin
                                valuePropName="checked"
                                tooltip='Al registrar entrada o salida, la app compara la cara del empleado con su fotografía dentro del propio celular. Requiere la checada remota activa.'
                                labelCol={{ span: 16 }} wrapperCol={{ span: 4 }}
                            >
                                <Switch disabled={!getFieldValue("appMovil") || !getFieldValue("checadaRemota") || this.bloqueado("verificacionFacial", getFieldValue)} />
                            </FormItem>
                        )}
                    </FormItem>
                    <FormItem shouldUpdate={(prev, cur) => prev.appMovil !== cur.appMovil || prev.checadaRemota !== cur.checadaRemota} noStyle>
                        {({ getFieldValue }) => (
                            <FormItem
                                label="Checar solo desde un celular"
                                name="celularUnicoChecada"
                                margin
                                valuePropName="checked"
                                tooltip='Cada empleado queda amarrado al primer celular con el que checa y no podrá checar desde otro hasta que un administrador lo desvincule. Si se apaga, puede checar desde cualquier celular donde inicie sesión.'
                                labelCol={{ span: 16 }} wrapperCol={{ span: 4 }}
                            >
                                <Switch disabled={!getFieldValue("appMovil") || !getFieldValue("checadaRemota")} />
                            </FormItem>
                        )}
                    </FormItem>
                </DynamicCardForm>
                <DynamicCardForm
                    title="WhatsApp"
                    style={{
                        width: "100%",
                        maxWidth: 400
                    }}
                >
                    {this.avisoModulo("whatsapp", "WhatsApp")}
                    <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) => {
                            if (!getFieldValue("whatsapp")) return null;
                            return (
                                <FormItem
                                    label="Números de la empresa"
                                    name="whatsappNumeroPorUsuario"
                                    margin
                                    initialValue={false}
                                    tooltip='Con "Un número para toda la empresa" todos envían y reciben desde la misma línea y los chats se reparten con la asignación de conversaciones. Con "Un número por usuario" cada vendedor conecta su propio número, el cliente lo reconoce y la asignación de conversaciones deja de usarse.'
                                    labelCol={{ span: 10 }} wrapperCol={{ span: 14 }}
                                >
                                    <SelectItem placeholder="Modo de números">
                                        <Option value={false}>Un número para toda la empresa</Option>
                                        <Option value={true}>Un número por usuario</Option>
                                    </SelectItem>
                                </FormItem>
                            );
                        }}
                    </FormItem>
                </DynamicCardForm>

            </>
        )

    }

    renderPdfGeneral() {
        return (
            <>
                {this.renderNota(
                    <>
                        Aquí se configura aspectos globales de <b>todos</b> los PDF. Para PDF específico ir a <b>Ventas › PDF</b> y <b>Compras › PDF</b>.
                    </>
                )}

                <Row gutter={[28, 0]}>
                    <Col xs={24} lg={12}>
                        <div className="config-dependientes" style={{ padding: "2px 6px", maxWidth: 300 }}>
                            <FormItem
                                label="Diseño de PDF"
                                name="tipoPDF"
                                marginBottom={8}
                                initialValue="clasico"
                                tooltip='Determina la plantilla visual usada al generar los PDF de remisiones y facturas. "Clásico" conserva el diseño actual; "Moderno" aplica el nuevo diseño.'
                                labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                            >
                                <SelectItem placeholder="Seleccionar diseño de PDF">
                                    <Option value="clasico">Clásico</Option>
                                    <Option value="moderno">Moderno</Option>
                                </SelectItem>
                            </FormItem>

                            <FormItem
                                label="Color del PDF"
                                name="colorPdf"
                                marginBottom={8}
                                initialValue="#00b5e2"
                                getValueFromEvent={this.normColor}
                                tooltip="Color de marca/acento usado en el diseño del PDF moderno."
                                labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                            >
                                <ColorPicker disabledAlpha format="hex" showText />
                            </FormItem>
                        </div>
                    </Col>

                    <Col xs={24} lg={12}>
                        <ConfigSwitch
                            name="imprimirIEPS"
                            titulo="Imprimir IEPS"
                            resumen="Agrega la columna de IEPS a los PDF del sistema."
                            maqueta={
                                <MockTable
                                    columns={[
                                        { label: "Concepto" },
                                        { label: "Importe" },
                                        { label: "IEPS", estado: "nuevo" },
                                    ]}
                                />
                            }
                            detalle="Si se activa se mostrará la columna de IEPS en los PDF del sistema."
                        />

                        <ConfigSwitch
                            name="imprimirDesUnidad"
                            titulo="Imprimir Descripción de Unidad"
                            resumen="Imprime la descripción de la unidad en lugar de su clave del SAT."
                            maqueta={
                                <MockDiff
                                    antes="H87"
                                    despues="Pieza"
                                />
                            }
                            detalle="Al activarse muestra la descripción de la unidad en lugar de la clave del sat en los PDF del módulo de Ventas y Compra."
                            ultimo
                        />
                    </Col>
                </Row>

                {this.renderDivider('Decimales en PDF')}
                <Row gutter={[12, 6]}>
                    <Col xs={24} md={12} lg={8}>
                        <div className="config-dependientes" style={{ padding: "2px 6px" }}>
                            <FormItem
                                label="Decimales Tipo de Cambio"
                                name="decimalesTipoCambioPdf"
                                marginBottom={8}
                                initialValue={4}
                                tooltip='Número de decimales con los que se imprime el tipo de cambio en los PDF.'
                                labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                            >
                                <SelectItem placeholder="Decimales Tipo de Cambio">
                                    <Option value={2}>2 decimales</Option>
                                    <Option value={3}>3 decimales</Option>
                                    <Option value={4}>4 decimales</Option>
                                </SelectItem>
                            </FormItem>
                        </div>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                        <div className="config-dependientes" style={{ padding: "2px 6px" }}>
                            <FormItem
                                label="Decimales Precio Unitario"
                                name="decimalesPrecioUnitarioPdf"
                                marginBottom={8}
                                initialValue={2}
                                tooltip='Número de decimales con los que se imprime el precio unitario en los PDF.'
                                labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                            >
                                <SelectItem placeholder="Decimales Precio Unitario">
                                    <Option value={2}>2 decimales</Option>
                                    <Option value={3}>3 decimales</Option>
                                    <Option value={4}>4 decimales</Option>
                                </SelectItem>
                            </FormItem>
                        </div>
                    </Col>

                    <Col xs={24} md={12} lg={8}>
                        <div className="config-dependientes" style={{ padding: "2px 6px" }}>
                            <FormItem
                                label="Decimales Cantidad"
                                name="decimalesCantidadPdf"
                                marginBottom={8}
                                initialValue={2}
                                tooltip='Número de decimales con los que se imprime la cantidad en los PDF.'
                                labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                            >
                                <SelectItem placeholder="Decimales Cantidad">
                                    <Option value={2}>2 decimales</Option>
                                    <Option value={3}>3 decimales</Option>
                                    <Option value={4}>4 decimales</Option>
                                </SelectItem>
                            </FormItem>
                        </div>
                    </Col>
                </Row>
            </>
        )
    }

    renderVentasPdf() {
        return (
            <>
                {this.renderVentasPdfOpciones()}
                {this.renderDivider('Textos')}
                {this.renderVentasPdfTextos()}
                {this.renderDivider('Pagaré')}
                {this.renderVentasPdfPagare()}
            </>
        )
    }
    renderVentasPdfOpciones() {
        return (
            <Row gutter={[28, 0]}>
                <Col xs={24} md={12} xl={8}>
                    <ConfigSwitch
                        name="quitarImpuestosRemisiones"
                        titulo="No Desglosar Imp. Remisiones"
                        resumen="La remisión muestra el total ya con impuestos, sin desglosarlos."
                        maqueta={
                            <MockDiff
                                antes="Subtotal, IVA y Total, cada uno en su renglón."
                                despues="Un solo Total, con los impuestos ya incluidos."
                            />
                        }
                        detalle="Se mostrara el total de la venta con impuestos en las remisiones (sin mostrar los impuestos)"
                    />

                    <ConfigSwitch
                        name="quitarImpuestosFacturas"
                        titulo="No Desglosar Imp. Facturas"
                        resumen="La factura muestra el total ya con impuestos, sin desglosarlos."
                        maqueta={
                            <MockDiff
                                antes="Subtotal, IVA y Total, cada uno en su renglón."
                                despues="Un solo Total, con los impuestos ya incluidos."
                            />
                        }
                        detalle="Se mostrara el total de la venta con impuestos en las facturas (sin mostrar los impuestos)"
                    />

                    <ConfigSwitch
                        name="importeConImpuestos"
                        titulo="Importe con Impuestos"
                        resumen="El importe de cada renglón de la factura y la remisión sale ya con impuestos."
                        aviso="No aplica al documento que tenga activo 'No Desglosar Imp.'"
                        maqueta={
                            <MockTable
                                columns={[
                                    { label: "Concepto" },
                                    { label: "P/U", sample: "$450.00" },
                                    { label: "IVA", sample: "$72.00" },
                                    { label: "Importe con Impuestos", estado: "nuevo", sample: "$522.00" },
                                ]}
                            />
                        }
                        detalle="En el PDF de la factura y de la remisión, el Importe de cada renglón incluye sus impuestos (IVA e IEPS) y ya descuenta el descuento del renglón. El P/U, la columna IVA y los totales no cambian. El XML timbrado no cambia."
                    />

                    <ConfigSwitch
                        name="ocultarColumnaIVA"
                        titulo="Quitar Columna IVA"
                        resumen="Quita la columna de IVA de cotización, pedido, factura y remisión."
                        imagen={capturas.col}
                        maqueta={
                            <MockTable
                                columns={[
                                    { label: "Concepto" },
                                    { label: "P/U" },
                                    { label: "IVA", estado: "oculto" },
                                    { label: "Importe" },
                                ]}
                            />
                        }
                        detalle="Se oculta la columna de IVA en los PDF de cotización, pedido, factura y remisión."
                    />

                    <ConfigSwitch
                        name="cantidadJuntoPrecioUnitario"
                        titulo="Cantidad junto a Precio Unitario"
                        resumen="Pone la columna Cantidad pegada a la de Precio Unitario."
                        imagen={capturas.cantidad}
                        detalle="Muestra la columna de Cantidad junto a la de Precio Unitario en los PDF de cotización, pedido, factura, remisión y embarque."
                    />

                    <ConfigSwitch
                        name="precioUnitarioConDescuento"
                        titulo="P/U con Descuento"
                        resumen="Agrega junto al P/U una columna con el precio unitario ya descontado, en cotización, pedido, embarque, factura y remisión."
                        aviso="La columna le quita ancho a la Descripción."
                        maqueta={
                            <MockTable
                                columns={[
                                    { label: "Concepto" },
                                    { label: "P/U", sample: "$500.00" },
                                    { label: "P/U c/Desc.", estado: "nuevo", sample: "$450.00" },
                                    { label: "Importe", sample: "$5,000.00" },
                                ]}
                            />
                        }
                        detalle="P/U c/Desc. = P/U menos el descuento del renglón (% y cantidad). Con 'No Desglosar Imp.' activo sale con impuestos, igual que el P/U. El Importe, los totales y el XML timbrado no cambian."
                    />

                    <ConfigSwitch
                        name="ocultarColumnaPU"
                        titulo="Quitar Columna P/U"
                        resumen="Quita el Precio Unitario de pedido y cotización."
                        aviso="No aplica a factura ni a remisión."
                        imagen={capturas.col}
                        maqueta={
                            <MockTable
                                columns={[
                                    { label: "Concepto" },
                                    { label: "Cant." },
                                    { label: "P/U", estado: "oculto" },
                                    { label: "Importe" },
                                ]}
                            />
                        }
                        detalle="Oculta la columna de Precio Unitario en la tabla de conceptos de pedido y cotización. No aplica a factura ni a remisión."
                    />

                    <ConfigSwitch
                        name="ocultarColumnaImporte"
                        titulo="Quitar Columna Importe"
                        resumen="Quita el Importe de pedido y cotización."
                        aviso="No aplica a factura ni a remisión."
                        imagen={capturas.col}
                        maqueta={
                            <MockTable
                                columns={[
                                    { label: "Concepto" },
                                    { label: "Cant." },
                                    { label: "P/U" },
                                    { label: "Importe", estado: "oculto" },
                                ]}
                            />
                        }
                        detalle="Oculta la columna de Importe en la tabla de conceptos de pedido y cotización. No aplica a factura ni a remisión."
                    />

                    <ConfigSwitch
                        name="deshabilitarClaveCot"
                        titulo="Deshabilitar Clave"
                        resumen="Quita la columna de Clave de los PDF de ventas."
                        imagen={capturas.clave}
                        maqueta={
                            <MockTable
                                columns={[
                                    { label: "Clave", estado: "oculto" },
                                    { label: "Concepto" },
                                    { label: "Importe" },
                                ]}
                            />
                        }
                        detalle="Si se activa no se mostrará la columna de Clave en los PDF del módulo de ventas."
                    />

                    <ConfigSwitch
                        name="deshabilitarClaveSATCot"
                        titulo="Deshabilitar Clave SAT"
                        resumen="Quita la columna de Clave SAT de los PDF de ventas."
                        imagen={capturas.clave}
                        maqueta={
                            <MockTable
                                columns={[
                                    { label: "Clave SAT", estado: "oculto" },
                                    { label: "Concepto" },
                                    { label: "Importe" },
                                ]}
                            />
                        }
                        detalle="Si se activa no se mostrará la columna de Clave Sat en los PDF del módulo de ventas."
                    />

                    <ConfigSwitch
                        name="ocultarCuadroTotalesPdf"
                        titulo="Ocultar Cuadro de Totales"
                        resumen="Quita el cuadro de Subtotal/Descuento/Impuestos/Total y el importe con letra."
                        aviso="No aplica a factura ni a remisión."
                        imagen={capturas.cuadroSubtotales}
                        detalle="Oculta el cuadro de Subtotal/Descuento/Impuestos/Total (y el importe con letra) en pedido y cotización. No aplica a factura ni a remisión."
                        ultimo
                    />
                </Col>
                <Col xs={24} md={12} xl={8}>
                    <ConfigSwitch
                        name="deshabilitarRegimenFiscal"
                        titulo="Deshabilitar Régimen Fiscal"
                        resumen="Quita el régimen fiscal de la empresa del encabezado."
                        aviso="No aplica a factura."
                        imagen={capturas.regimenFiscal}
                        detalle="Si se activa no se mostrará el dato del Régimen fiscal de la empresa en los PDF. (Excepto en las facturas)."
                    />

                    <ConfigSwitch
                        name="deshabilitarTipoComprobantePdf"
                        titulo="Deshabilitar Tipo de Comprobante"
                        resumen="Quita la leyenda “Tipo De Comprobante” del encabezado."
                        aviso="No aplica a factura."
                        maqueta={
                            <MockFrame title="Encabezado del PDF">
                                <MockField label="Tipo De Comprobante" value="Ingreso" estado="oculto" width={100} />
                            </MockFrame>
                        }
                        detalle='Oculta la leyenda "Tipo De Comprobante" en remisión, pedido y cotización. No aplica a factura.'
                    />

                    <ConfigSwitch
                        name="deshabilitarMonedaPdf"
                        titulo="Deshabilitar Moneda"
                        resumen="Quita la moneda del encabezado."
                        aviso="No aplica a factura."
                        maqueta={
                            <MockFrame title="Encabezado del PDF">
                                <MockField label="Moneda" value="MXN" estado="oculto" width={70} />
                            </MockFrame>
                        }
                        detalle="Oculta el dato de Moneda en el encabezado de remisión, pedido y cotización. No aplica a factura."
                    />

                    <ConfigSwitch
                        name="deshabilitarLugarExpedicionPdf"
                        titulo="Deshabilitar Lugar de Expedición"
                        resumen="Quita el lugar de expedición del encabezado."
                        aviso="No aplica a factura."
                        maqueta={
                            <MockFrame title="Encabezado del PDF">
                                <MockField label="Lugar de Expedición" value="45050" estado="oculto" width={90} />
                            </MockFrame>
                        }
                        detalle="Oculta el Lugar de expedición en remisión, pedido y cotización. No aplica a factura."
                    />

                    <ConfigSwitch
                        name="deshabilitarCondicionesPagoPdf"
                        titulo="Deshabilitar Condiciones de Pago"
                        resumen="Quita las condiciones de pago del encabezado."
                        aviso="No aplica a factura."
                        maqueta={
                            <MockFrame title="Encabezado del PDF">
                                <MockField label="Condiciones de Pago" value="30 días" estado="oculto" width={90} />
                            </MockFrame>
                        }
                        detalle="Oculta las Condiciones de pago en remisión, pedido y cotización. No aplica a factura."
                    />

                    <ConfigSwitch
                        name="deshabilitarOCPdf"
                        titulo="Deshabilitar Orden de Compra"
                        resumen="Quita el dato de Orden de Compra (O.C.) del encabezado."
                        maqueta={
                            <MockFrame title="Encabezado del PDF">
                                <MockField label="O.C." value="OC-1042" estado="oculto" width={90} />
                            </MockFrame>
                        }
                        detalle="Oculta el dato de Orden de Compra (O.C.) en remisión, pedido, cotización y factura."
                    />

                    <ConfigSwitch
                        name="deshabilitarCPClientePdf"
                        titulo="Deshabilitar C.P. del Cliente"
                        resumen="Quita el código postal del cliente del encabezado."
                        aviso="No aplica a factura."
                        maqueta={
                            <MockFrame title="Datos del cliente">
                                <MockField label="C.P." value="44100" estado="oculto" width={70} />
                            </MockFrame>
                        }
                        detalle="Oculta el C.P. del cliente en remisión, pedido y cotización. No aplica a factura."
                    />

                    <ConfigSwitch
                        name="deshabilitarFormaPagoPdf"
                        titulo="Deshabilitar Forma de Pago"
                        resumen="Quita la forma de pago del encabezado."
                        aviso="No aplica a factura."
                        maqueta={
                            <MockFrame title="Encabezado del PDF">
                                <MockField label="Forma de Pago" value="03 Transferencia" estado="oculto" width={110} />
                            </MockFrame>
                        }
                        detalle="Oculta la Forma de pago en remisión, pedido y cotización. No aplica a factura."
                    />

                    <ConfigSwitch
                        name="deshabilitarFechaPdf"
                        titulo="Deshabilitar Fecha"
                        resumen="Quita la fecha del documento del encabezado."
                        aviso="No aplica a factura."
                        maqueta={
                            <MockFrame title="Encabezado del PDF">
                                <MockField label="Fecha" value="11/09/2026" estado="oculto" width={90} />
                            </MockFrame>
                        }
                        detalle="Oculta la fecha del documento en remisión, pedido y cotización. No aplica a factura."
                    />

                    <ConfigSwitch
                        name="deshabilitarFechaEntregaPdf"
                        titulo="Deshabilitar Fecha de Entrega Estimada"
                        resumen="Quita la fecha de entrega estimada del encabezado."
                        maqueta={
                            <MockFrame title="Encabezado del PDF">
                                <MockField label="Fecha de Entrega" value="18/09/2026" estado="oculto" width={90} />
                            </MockFrame>
                        }
                        detalle="Oculta la fecha de entrega estimada en remisión, pedido, cotización y factura."
                        ultimo
                    />
                </Col>

                {/* Columna 3: Entrega, firma, banco y extras */}
                <Col xs={24} md={12} xl={8}>
                    <ConfigSwitch
                        name="deshabilitarMetodoPagoPdf"
                        titulo="Deshabilitar Método de Pago"
                        resumen="Quita el método de pago del encabezado."
                        aviso="No aplica a factura."
                        maqueta={
                            <MockFrame title="Encabezado del PDF">
                                <MockField label="Método de Pago" value="PUE" estado="oculto" width={80} />
                            </MockFrame>
                        }
                        detalle="Oculta el Método de pago en remisión, pedido y cotización. No aplica a factura."
                    />

                    <ConfigSwitch
                        name="mostrarDirFiscalEnPdf"
                        titulo="Mostrar Dir. Fiscal"
                        resumen="Si la venta no trae dirección de entrega, imprime la fiscal."
                        maqueta={
                            <MockDiff
                                antes="Sin dirección de entrega, el bloque sale vacío."
                                despues="Sin dirección de entrega, se imprime la dirección fiscal."
                            />
                        }
                        detalle="Si no viene la dirección de entrega poner la dirección fiscal."
                    />

                    <ConfigSwitch
                        name="mostrarReferenciaEntregaPdf"
                        titulo="Mostrar Referencia de Dirección de Entrega"
                        resumen="Imprime la referencia del cliente arriba de la dirección de entrega."
                        maqueta={
                            <MockFrame title="Dirección de Entrega">
                                <MockField label="Referencia" value="Portón azul, entre 5ta y 6ta" estado="nuevo" width={140} />
                            </MockFrame>
                        }
                        detalle="Muestra la Referencia guardada en la dirección del cliente, arriba del bloque de Dirección de Entrega. Aplica a remisión, pedido, cotización y factura."
                    />

                    <ConfigSwitch
                        name="camposFirmaVentas"
                        titulo="Firma de Entrega y Recibió"
                        resumen="Agrega al pie un bloque para firmar quién entregó y quién recibió."
                        imagen={capturas.firma}
                        detalle='Agrega un bloque de firmas "Entregó"/"Recibió" al final del PDF de remisión, pedido, cotización y factura.'
                    />

                    <ConfigSwitch
                        name="deshabilitarBanco"
                        titulo="Deshabilitar Banco"
                        resumen="Los PDF de ventas salen sin los datos del banco."
                        imagen={capturas.banco}
                        detalle="Si se activa se ocultaran por defecto los datos del banco en los PDF del módulo de ventas."
                    />

                    <ConfigSwitch
                        name="deshabilitarBancoFactura"
                        titulo="Deshabilitar Banco en Factura"
                        resumen="La factura nunca imprime los datos del banco, aunque el documento lo pida."
                        aviso="No afecta remisión, pedido ni cotización."
                        maqueta={
                            <MockDiff
                                antes='La casilla "Imprimir Banco" del documento decide.'
                                despues="La factura nunca lleva datos del banco."
                            />
                        }
                        detalle='Si se activa, nunca se muestran los datos del banco en las facturas, sin importar la casilla de "Imprimir Banco" del documento. No afecta remisión, pedido ni cotización.'
                    />

                    <ConfigSwitch
                        name="mostrarProyectoVentas"
                        titulo="Mostrar datos del proyecto"
                        resumen="Los PDF de ventas incluyen los datos del proyecto."
                        imagen={capturas.proyecto}
                        detalle="Se mostrarán los datos del proyecto en los PDF de la sección de ventas."
                    />

                    <ConfigSwitch
                        name="vendedorVentas"
                        titulo="Vendedor en Pdf"
                        resumen="El PDF de la venta muestra quién la vendió."
                        imagen={capturas.vendedor}
                        detalle="Se activa la visualización del vendedor en el pdf de la venta"
                        ultimo
                    />
                </Col>
            </Row>
        )
    }

    renderVentasPdfTextos() {
        return (
            <>
                {/* Fila 1: 2 cards alargadas */}
                <Row gutter={[16, 16]}>
                    <Col xs={24} md={12}>
                        <DynamicCardForm
                            title={
                                <span>
                                    Observación Predeterminada (Factura y Remisiones)
                                    <Tooltip title="Texto al final de PDFs de factura y remisión." placement="right">
                                        <QuestionCircleOutlined style={{ marginLeft: 8, color: '#00BFD6', cursor: 'pointer' }} />
                                    </Tooltip>
                                </span>
                            }
                            style={{ marginBottom: 0 }}
                        >
                            <FormItem
                                name="textoAdicional"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                margin
                            >
                                <RichTextEditor
                                    placeholder="Texto Adicional"
                                    height={140}
                                    style={{ width: '100%' }}
                                    plainText
                                />
                            </FormItem>
                            <FormItem
                                label="Tamaño de Texto"
                                name="tamañoTextoAdicional"
                                margin
                                initialValue={false}
                                tooltip='Esta casilla sirve para definir el tamaño del texto adicional en los PDFs de factura y remision.'
                            >
                                <InputNumberItem placeholder="Tamaño de Texto Adicional" />
                            </FormItem>
                        </DynamicCardForm>
                    </Col>

                    <Col xs={24} md={12}>
                        <DynamicCardForm
                            title={
                                <span>
                                    Observación Predeterminada (Pedidos y Cotizaciones)
                                    <Tooltip title="Texto al final de PDFs de pedidos y cotizaciones." placement="right">
                                        <QuestionCircleOutlined style={{ marginLeft: 8, color: '#00BFD6', cursor: 'pointer' }} />
                                    </Tooltip>
                                </span>
                            }
                            style={{ marginBottom: 0 }}
                        >
                            <FormItem
                                name="textoAdicionalPedidosCotizaciones"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                margin
                            >
                                <RichTextEditor
                                    placeholder="Texto Adicional Pedidos y Cotizaciones"
                                    height={140}
                                    style={{ width: '100%' }}
                                    plainText
                                />
                            </FormItem>
                            <FormItem
                                label="Tamaño de Texto"
                                name="tamañoTextoAdicionalPedidosCotizaciones"
                                margin
                                initialValue={false}
                                tooltip='Esta casilla sirve para definir el tamaño del texto adicional en los PDFs de pedidos y cotizaciones.'
                            >
                                <InputNumberItem placeholder="Tamaño de Texto Adicional Pedidos y Cotizaciones" />
                            </FormItem>
                        </DynamicCardForm>
                    </Col>
                </Row>

                {/* Fila 2: 2 cards alargadas */}
                <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24} md={12}>
                        <DynamicCardForm
                            title={
                                <span>
                                    Observación Predeterminada (Ticket Remisión)
                                    <Tooltip title="Esta casilla sirve para añadir un texto al final de los PDFs de los tickets de remisión." placement="right">
                                        <QuestionCircleOutlined style={{ marginLeft: 8, color: '#00BFD6', cursor: 'pointer' }} />
                                    </Tooltip>
                                </span>
                            }
                            style={{ marginBottom: 0 }}
                        >
                            <FormItem
                                name="textoAdicionalTicketRemision"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                            >
                                <RichTextEditor
                                    placeholder="Texto Adicional"
                                    height={100}
                                    style={{ width: '100%' }}
                                    plainText
                                />
                            </FormItem>
                        </DynamicCardForm>
                    </Col>

                    <Col xs={24} md={12}>
                        <DynamicCardForm
                            title={
                                <span>
                                    Observación Predeterminada (Ticket Factura)
                                    <Tooltip title="Esta casilla sirve para añadir un texto al final de los PDFs de los tickets de factura." placement="right">
                                        <QuestionCircleOutlined style={{ marginLeft: 8, color: '#00BFD6', cursor: 'pointer' }} />
                                    </Tooltip>
                                </span>
                            }
                            style={{ marginBottom: 0 }}
                        >
                            <FormItem
                                name="textoAdicionalTicketFactura"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                            >
                                <RichTextEditor
                                    placeholder="Texto Adicional"
                                    height={100}
                                    style={{ width: '100%' }}
                                    plainText
                                />
                            </FormItem>
                        </DynamicCardForm>
                    </Col>
                </Row>
            </>
        )
    }


    renderVentasPdfPagare() {
        return (
            <>
                {/* Los dos interruptores comparten columna: "Pagaré Corto" no
                    se sangra, para que su switch caiga en la misma vertical
                    que el de "Activar Pagaré". */}
                <div style={{ maxWidth: 640 }}>
                    <ConfigSwitch
                        name="activarPagare"
                        titulo="Activar Pagaré"
                        resumen="Agrega el pagaré a las ventas."
                        detalle="Al activar esta casilla se activa el pagaré en ventas."
                    />

                    <FormItem shouldUpdate noStyle>
                        {({ getFieldValue }) =>
                            getFieldValue("activarPagare") && (
                                <ConfigSwitch
                                    name="pagareCorto"
                                    titulo="Pagaré Corto"
                                    resumen="Usa la versión corta del pagaré."
                                    detalle="Activa el pagaré corto."
                                    ultimo
                                />
                            )
                        }
                    </FormItem>
                </div>

                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) =>
                        getFieldValue("activarPagare") && (

                            <Row gutter={[16, 16]} align="top" style={{ marginTop: 12 }}>

                                <Col xs={24} xl={16} style={{ minWidth: 0 }}>
                                    <DynamicCardForm
                                        title={
                                            <span>
                                                Texto del Pagaré
                                                <Tooltip title="No agregar firma, solo el texto." placement="right">
                                                    <QuestionCircleOutlined style={{ marginLeft: 8, color: '#00BFD6', cursor: 'pointer' }} />
                                                </Tooltip>
                                            </span>
                                        }
                                        style={{ marginBottom: 0 }}
                                    >
                                        <FormItem
                                            name="textoPagare"
                                            labelCol={{ span: 24 }}
                                            wrapperCol={{ span: 24 }}
                                            margin
                                        >
                                            <RichTextEditor
                                                ref={this.pagareEditorRef}
                                                placeholder="Pagaré"
                                                height={this.state.isMobile ? 200 : 300}
                                                style={{ width: '100%', display: 'block' }}
                                                plainText
                                            />
                                        </FormItem>
                                        <FormItem
                                            label="Tamaño de Texto"
                                            name="tamañoTextoPagare"
                                            margin
                                            initialValue={false}
                                            tooltip='Esta casilla sirve para definir el tamaño del pagaré en los PDFs de factura y remision.'
                                        >
                                            <InputNumberItem placeholder="Tamaño de Texto Pagare" />
                                        </FormItem>
                                    </DynamicCardForm>
                                </Col>

                                <Col xs={24} xl={8}>
                                    <Text strong style={{ display: "block", marginBottom: 8, fontSize: this.state.isMobile ? 11 : 13 }}>
                                        Textos dinámicos disponibles
                                    </Text>
                                    <div style={{
                                        display: "grid",
                                        gridTemplateColumns: this.state.isMobile ? "1fr 1fr" : "1fr 1fr",
                                        gap: this.state.isMobile ? 4 : 6,
                                    }}>
                                        {TEXTOS_PAGARE.map(({ key, desc }) => (
                                            <div
                                                key={key}
                                                onClick={() => this.pagareEditorRef.current?.insertText(key)}
                                                style={{
                                                    background: "#ffffff",
                                                    border: "1px solid #a0ce7c",
                                                    borderRadius: 4,
                                                    padding: this.state.isMobile ? "3px 4px" : "4px 6px",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <Text style={{ fontFamily: "monospace", fontSize: this.state.isMobile ? 9 : 10, color: "#389e0d", fontWeight: 600, lineHeight: 1.3, display: "block" }}>
                                                    {key}
                                                </Text>
                                                <Text type="secondary" style={{ fontSize: this.state.isMobile ? 8 : 9, lineHeight: 1.2, display: "block" }}>
                                                    {desc}
                                                </Text>
                                            </div>
                                        ))}
                                    </div>

                                </Col>

                            </Row>

                        )
                    }
                </FormItem>
            </>
        )
    }

    renderComprasPdf() {
        return (
            <>
                <div style={{ maxWidth: 640 }}>
                    <ConfigSwitch
                        name="deshabilitarClaveInterna"
                        titulo="Deshabilitar Clave Interna en PDF"
                        resumen="Quita la columna de clave interna del PDF de órdenes de compra y requisiciones."
                        maqueta={
                            <MockTable
                                columns={[
                                    { label: "Clave interna", estado: "oculto" },
                                    { label: "Insumo" },
                                    { label: "Cant." },
                                ]}
                            />
                        }
                        detalle="Se activa que no se imprima la columna clave interna en el pdf de Ordenes de Compra y de Requisiciones"
                    />

                    <ConfigSwitch
                        name="imprimirDescripcionInsumoOC"
                        titulo="Descripción del insumo en PDF de Orden de Compra"
                        resumen="Cada fila del PDF de la orden de compra muestra también la descripción del insumo en el sistema."
                        maqueta={
                            <MockFrame title="PDF de la orden de compra">
                                <MockField label="Descripción" value="CAJA GUANTE NITRILO M" width={140} />
                                <MockField label="Insumo" value="GUANTE DE NITRILO M" estado="nuevo" width={140} />
                            </MockFrame>
                        }
                        detalle="Debajo de la descripción del proveedor se imprime la descripción del insumo en el sistema, si es distinta. Aplica al PDF que se descarga, al que se manda por correo o WhatsApp y a la descarga masiva."
                        ultimo
                    />
                </div>

                {/* Card de observaciones debajo */}
                <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
                    <Col xs={24} md={12}>
                        <DynamicCardForm
                            title={
                                <span>
                                    Observación Predeterminada (Orden de compra)
                                    <Tooltip title="Esta casilla sirve para añadir observaciones en el pdf de orden de compra." placement="right">
                                        <QuestionCircleOutlined style={{ marginLeft: 8, color: '#00BFD6', cursor: 'pointer' }} />
                                    </Tooltip>
                                </span>
                            }
                            style={{ marginBottom: 0 }}
                        >
                            <FormItem
                                name="observacionesPdf"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                            >
                                <RichTextEditor
                                    placeholder="Observaciones"
                                    height={140}
                                    style={{ width: '100%' }}
                                    plainText
                                />
                            </FormItem>
                        </DynamicCardForm>
                    </Col>
                </Row>
            </>
        )
    }
    renderPagosCuentasPorPagar() {
        return (
            <div style={{ maxWidth: 640 }}>
                <ConfigSwitch
                    name="cuentasImpagables"
                    titulo="Cuentas Impagables"
                    resumen="Permite marcar una cuenta por pagar como impagable."
                    detalle="Se activa que las CXP se puedan hacer impagables."
                />

                <ConfigSwitch
                    name="cuentasAjusteCentavosCxP"
                    titulo="Cuentas Ajuste Centavos"
                    resumen="Permite quitar la diferencia de centavos al pagar."
                    detalle="Se activa que las CXP se puedan quitar la diferencia de centavos."
                />

                <ConfigSwitch
                    name="desactivarSeparacionMovimientosPagos"
                    titulo="Desactivar Separación de Movimientos por Factura"
                    resumen="Registra un solo movimiento con el monto total, en lugar de uno por cada factura pagada."
                    maqueta={
                        <MockDiff
                            antes="Un cargo o abono por cada factura pagada, con su propio monto."
                            despues="Un solo movimiento con el monto total del pago."
                        />
                    }
                    detalle="Si se desactiva esta casilla, al pagar varias facturas de un proveedor en un mismo pago, el cargo o abono a la cuenta del proveedor se registra por separado para cada factura (con su propio monto), para poder identificar en la póliza cuánto correspondió a cada una. Si se activa, se registra un solo movimiento con el monto total, como funciona actualmente."
                />

                <ConfigSwitch
                    name="pagoConCuentaContableCxP"
                    titulo="Pago con Cuenta Contable"
                    resumen="Permite pagar, junto con la factura, un monto extra que se registra contra una cuenta contable."
                    detalle="Al pagar una factura (sola o varias del proveedor) por banco se puede capturar un monto extra que sale del mismo banco y se carga a una cuenta contable. La factura se paga igual que siempre; en la póliza el banco abona la factura más el extra y la cuenta contable recibe el cargo del extra. La cuenta que se indica aquí viene seleccionada al pagar y se puede cambiar."
                    ultimo
                />

                <FormItem shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                        if (getFieldValue('pagoConCuentaContableCxP')) {
                            return (
                                <ConfigDependientes>
                                    <FormItem
                                        label="Cuenta contable predefinida"
                                        name="cuentaContablePagoCxPId"
                                        marginBottom={8}
                                        required
                                        tooltip='Cuenta contable que viene seleccionada al pagar una parte con cuenta contable. Se puede cambiar en cada pago.'
                                        labelCol={{ span: 24 }} wrapperCol={{ span: 24 }} labelAlign="left"
                                    >
                                        <SelectItem placeholder="Cuenta contable">
                                            {this.state.objetoCuentaContable}
                                        </SelectItem>
                                    </FormItem>
                                </ConfigDependientes>
                            )
                        }
                    }}
                </FormItem>
            </div>
        )

    }

    indiceBusqueda = () => {
        if (this._indice) return this._indice;

        const CAMPOS = ["titulo", "resumen", "detalle", "aviso", "label", "placeholder"];

        const textoDe = (nodo, acc) => {
            if (nodo === null || nodo === undefined || typeof nodo === "boolean") return acc;
            if (typeof nodo === "string" || typeof nodo === "number") {
                acc.push(String(nodo));
                return acc;
            }
            if (Array.isArray(nodo)) {
                nodo.forEach((n) => textoDe(n, acc));
                return acc;
            }
            if (!React.isValidElement(nodo)) return acc;

            const p = nodo.props || {};
            // El texto de una opción puede venir como cadena o como nodo
            // (cuando nombra un botón o un módulo con RefBoton / RefModulo).
            // En el segundo caso se baja por dentro para no perderlo del índice.
            CAMPOS.forEach((k) => {
                const valor = p[k];
                if (typeof valor === "string" || typeof valor === "number") {
                    acc.push(String(valor));
                } else if (valor) {
                    textoDe(valor, acc);
                }
            });
            if (typeof p.name === "string") acc.push(p.name);
            else if (Array.isArray(p.name)) acc.push(p.name.join(" "));

            if (typeof p.children === "function") {
                try {
                    textoDe(p.children({ getFieldValue: () => true }), acc);
                } catch (e) {                    
                }
            } else if (p.children) {
                textoDe(p.children, acc);
            }
            return acc;
        };

        const textoDePantalla = (seccion, subseccion) => {
            try {
                return textoDe(this.renderContenido(seccion, subseccion), []).join(" ");
            } catch (e) {
                return "";
            }
        };

        const indice = {};
        for (const item of MENU_ITEMS) {
            if (!item || !item.key) continue;
            indice[item.key] = textoDePantalla(item.key, null);

            const subs = SUBSECCIONES[item.key];
            if (!Array.isArray(subs)) continue;
            for (const sub of subs) {
                indice[`${item.key}/${sub.key}`] = textoDePantalla(item.key, sub.key);
            }
        }

        this._indice = indice;
        return indice;
    };

    renderContenido(seccion, subseccion) {
        subseccion = subseccion || 'general';

        if (seccion === 'ventas') {
            switch (subseccion) {
                case 'general': return this.renderVentasGeneral();
                case 'embarques': return this.renderVentasEmbarques();
                case 'cotizaciones': return this.renderVentasCotizaciones();
                case 'cotizadorInsumo': return this.renderVentasCotizadorInsumo();
                case 'preCotizacion': return this.renderVentasPreCotizacion();
                case 'pedidos': return this.renderVentasPedidos();
                case 'facturas': return this.renderVentasFacturas();
                case 'series': return this.renderVentasSeries();
                case 'kiosco': return this.renderVentasKiosco();
                case 'vencimientos': return this.renderVentasVencimientos();
                case 'devolucionesVenta': return this.renderVentasDevoluciones();
                case 'pdf': return this.renderVentasPdf();
                default: return this.renderSeccionLibre(seccion, subseccion);
            }
        }
        if (seccion === 'cobranza') {
            switch (subseccion) {
                case 'general': return this.renderCobranzaGeneral();
                case 'cuentasPorCobrar': return this.renderCobranzaCuentasPorCobrar();
                default: return this.renderSeccionLibre(seccion, subseccion);
            }
        }
        if (seccion === 'compras') {
            switch (subseccion) {
                case 'general': return this.renderComprasGeneral();
                case 'requisiciones': return this.renderComprasRequisiciones();
                case 'workbenchRequisiciones': return this.renderComprasWorkbench();
                case 'ordenesCompra': return this.renderComprasOrdenesCompra();
                case 'facturas': return this.renderComprasFacturas();
                case 'comodato': return this.renderComprasComodato();
                case 'prorrateos': return this.renderComprasProrrateos();
                case 'devolucionesCompra': return this.renderComprasDevoluciones();
                case 'pdf': return this.renderComprasPdf();
                default: return this.renderSeccionLibre(seccion, subseccion);
            }
        }
        if (seccion === 'pagos') {
            switch (subseccion) {
                case 'cuentasPorPagar': return this.renderPagosCuentasPorPagar();
                default: return this.renderSeccionLibre(seccion, subseccion);
            }
        }
        if (seccion === 'capitalHumano') {
            switch (subseccion) {
                case 'general': return this.renderCapitalHumanoGeneral();
                case 'empleados': return this.renderCapitalHumanoEmpleados();
                case 'preNomina': return this.renderCapitalHumanoPreNomina();
                default: return this.renderSeccionLibre(seccion, subseccion);
            }
        }
        if (seccion === 'inventario') {
            switch (subseccion) {
                case 'lotes': return this.renderInventarioLotes();
                case 'movimientosInventario': return this.renderInventarioMovimientos();
                default: return this.renderSeccionLibre(seccion, subseccion);
            }
        }
        if (seccion === 'proveedores') {
            switch (subseccion) {
                case 'evaluacionProveedores': return this.renderProveedoresEvaluacion();
                default: return this.renderSeccionLibre(seccion, subseccion);
            }
        }
        if (seccion === 'clientes') {
            switch (subseccion) {
                case 'escuela': return this.renderClientesEscuela();
                default: return this.renderSeccionLibre(seccion, subseccion);
            }
        }
        if (seccion === 'finanzas') {
            switch (subseccion) {
                case 'polizas': return this.renderFinanzasPolizas();
                default: return this.renderSeccionLibre(seccion, subseccion);
            }
        }

        // Secciones sin segundo nivel: una sola pantalla
        if (seccion === 'general') return this.renderSectionGeneral();
        if (seccion === 'calidad') return this.renderSectionCalidad();
        if (seccion === 'dropshipping') return this.renderSectionDropshipping();
        if (seccion === 'pdf') return this.renderPdfGeneral();
        const UNA_PANTALLA = {
            envios: this.renderSectionEnvios,
            insumos: this.renderSectionInsumos,
            puntoVenta: this.renderPuntoVentaGeneral,
            controlAsistencia: this.renderControlAsistencia,
            consignaciones: this.renderConsignaciones,
            conteos: this.renderConteos,
            wms: this.renderWms,
            activosFijos: this.renderActivosFijos,
            mantenimiento: this.renderMantenimiento,
            produccion: this.renderProduccion,
            hotel: this.renderHotel,
            crm: this.renderCrm,
            medico: this.renderMedico,
            mezcal: this.renderMezcal,
        };
        if (UNA_PANTALLA[seccion] && subseccion === 'general') {
            return UNA_PANTALLA[seccion].call(this);
        }
        return this.renderSeccionLibre(seccion, subseccion);
    }

    render() {
        return (
            <Spin spinning={this.state.loading}>
                <Form
                    name="complementosConfiguracion"
                    layout
                    onFinish={this.onFinish.bind(this)}
                    onFinishFailed={this.onFinishFailed}
                    ref={this.formRef}
                >
                    <ModulosBiwoContext.Provider value={this.state.modulosBiwo}>
                    <SidebarMenu
                        menuItems={MENU_ITEMS}
                        sectionTitles={SECTION_TITLES}
                        subsections={SUBSECCIONES}
                        defaultSelected="general"
                        siderWidth={255}
                        searchable
                        searchPlaceholder="Buscar módulo u opción..."
                        searchTerms={this.indiceBusqueda}
                        renderContent={(seccion, subseccion) => this.renderContenido(seccion, subseccion)}
                        footer={
                            <ButtonItem
                                cyan
                                type="primary"
                                htmlType="submit"
                                style={{
                                    minWidth: 120,
                                    height: 30,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                Guardar Configuración
                            </ButtonItem>
                        }
                    />
                    </ModulosBiwoContext.Provider>
                </Form>
            </Spin>
        );
    }
}
const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(ComplementosConfiguracion);
